import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  collection, addDoc, updateDoc, deleteDoc, doc, getDoc, getDocs,
  onSnapshot, query, orderBy, where, serverTimestamp, setDoc, limit
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "./firebase";
import QRCode from "qrcode";
import { Html5Qrcode } from "html5-qrcode";

const GOLD   = "#D4AF37";
const DARK   = "#09090c";
const BORDER = "rgba(255,255,255,0.08)";

// ─── CSS COMPLET MOBILE-FIRST ───────────────────────────────────────────
// IMPORTANT: mobile e default, desktop e @media (min-width: 769px)
// Sidebar ASCUNS implicit, apare DOAR pe desktop
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=DM+Sans:wght@300;400;500;600&display=swap');

  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;-webkit-tap-highlight-color:transparent;}
  html{height:100%;-webkit-text-size-adjust:100%;}
  body{
    height:100%;background:#09090c;color:#e0e0e0;
    font-family:'DM Sans',-apple-system,sans-serif;
    -webkit-font-smoothing:antialiased;overflow-x:hidden;
  }
  input,textarea,select,button{
    font-family:'DM Sans',-apple-system,sans-serif;
    font-size:16px;-webkit-appearance:none;border-radius:0;
  }
  a{color:inherit;text-decoration:none;}
  ::-webkit-scrollbar{width:3px;height:3px;}
  ::-webkit-scrollbar-track{background:transparent;}
  ::-webkit-scrollbar-thumb{background:rgba(212,175,55,0.25);border-radius:2px;}

  @keyframes fadeUp{from{opacity:0;transform:translateY(8px);}to{opacity:1;transform:translateY(0);}}
  .fu{animation:fadeUp 0.3s ease both;}

  /* ── SHELL: coloana pe mobile ── */
  .shell{
    display:flex;
    flex-direction:column;
    min-height:100vh;
    min-height:-webkit-fill-available;
  }

  /* ── TOP BAR: vizibil pe mobile ── */
  .topbar{
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:8px;
    padding:12px 16px;
    padding-top:calc(12px + env(safe-area-inset-top,0px));
    background:#0d0d10;
    border-bottom:1px solid rgba(255,255,255,0.08);
    position:sticky;
    top:0;
    z-index:100;
    flex-shrink:0;
    min-height:calc(52px + env(safe-area-inset-top,0px));
  }

  /* ── SCROLL AREA ── */
  .scroll{
    flex:1;
    overflow-y:auto;
    -webkit-overflow-scrolling:touch;
    padding:14px 14px;
    padding-bottom:calc(76px + env(safe-area-inset-bottom,0px));
  }

  /* ── BOTTOM NAV: vizibil pe mobile ── */
  .bnav-inner::-webkit-scrollbar{display:none;}
  .nb{
    flex:0 0 auto;
    width:64px;
    min-width:64px;
    box-sizing:border-box;
    display:flex;flex-direction:column;
    align-items:center;justify-content:center;
    gap:3px;padding:9px 4px;
    background:none;border:none;cursor:pointer;
    color:#444;transition:color 0.15s;
    min-height:56px;
    font-family:'DM Sans',sans-serif;
    -webkit-tap-highlight-color:transparent;
  }

  .nb.on{color:#D4AF37;}
  .nb.on .ni{
    background:rgba(212,175,55,0.12);
    border-radius:10px;
    padding:4px 8px;
  }
  .ni{font-size:18px;line-height:1;transition:all 0.15s;}
  .nl{font-size:9px;font-weight:500;white-space:nowrap;color:inherit;}

  /* ── SIDEBAR: ASCUNS pe mobile, vizibil pe desktop ── */
  .sidebar{display:none;}

  /* ─── DESKTOP ─── */
  @media(min-width:769px){
    .topbar{display:none;}
    .bnav{display:none;}
    .scroll{padding:32px 36px;padding-bottom:32px;}
    .shell{flex-direction:row;}
    .sidebar{
      display:flex;
      flex-direction:column;
      width:220px;
      flex-shrink:0;
      background:linear-gradient(180deg,#0f0f14,#09090c);
      border-right:1px solid rgba(255,255,255,0.08);
      height:100vh;
      position:sticky;top:0;
      overflow-y:auto;
      padding:26px 14px;
    }
  }

  /* ── CARD ── */
  .card{
    background:rgba(255,255,255,0.03);
    border:1px solid rgba(255,255,255,0.08);
    border-radius:14px;
    padding:14px;
    margin-bottom:10px;
  }

  /* ── STAT GRID ── */
  .sg{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:16px;}
  @media(min-width:600px){.sg{grid-template-columns:repeat(4,1fr);}}

  /* ── FORM ── */
  .f{margin-bottom:13px;}
  .f label{display:block;font-size:11px;color:#666;text-transform:uppercase;letter-spacing:1px;margin-bottom:5px;}
  .fi{
    width:100%;background:rgba(255,255,255,0.04);
    border:1px solid rgba(255,255,255,0.08);
    border-radius:10px;padding:12px 13px;
    color:#eee;font-size:16px;outline:none;
    resize:vertical;-webkit-appearance:none;
    display:block;min-height:48px;
    font-family:'DM Sans',sans-serif;
  }
  .fi:focus{border-color:rgba(212,175,55,0.4);}
  select.fi{background-image:none;}

  /* ── BUTTONS ── */
  .btn{
    display:inline-flex;align-items:center;justify-content:center;
    gap:6px;border:none;cursor:pointer;
    font-weight:600;font-family:'DM Sans',sans-serif;
    border-radius:10px;transition:opacity 0.15s;
    white-space:nowrap;padding:11px 18px;font-size:13px;
    min-height:44px;
  }
  .btn:active{opacity:0.72;}
  .btn:disabled{opacity:0.45;cursor:not-allowed;}
  .full{width:100%;padding:13px;font-size:14px;}
  .sm{min-height:36px;padding:7px 12px;font-size:11px;border-radius:8px;}
  .gold{background:linear-gradient(135deg,#D4AF37,#C49B30);color:#0a0a0d;}
  .blue{background:linear-gradient(135deg,#3498DB,#2980B9);color:#fff;}
  .grn{background:linear-gradient(135deg,#2ECC71,#27AE60);color:#fff;}
  .pur{background:linear-gradient(135deg,#9B59B6,#8E44AD);color:#fff;}
  .red{background:linear-gradient(135deg,#E74C3C,#C0392B);color:#fff;}
  .gh{background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.08);color:#888;}
  .gh-g{background:rgba(212,175,55,0.08);border:1px solid rgba(212,175,55,0.25);color:#D4AF37;}
  .gh-b{background:rgba(52,152,219,0.08);border:1px solid rgba(52,152,219,0.25);color:#3498DB;}
  .gh-r{background:rgba(231,76,60,0.08);border:1px solid rgba(231,76,60,0.25);color:#E74C3C;}

  /* ── BADGE ── */
  .badge{display:inline-flex;align-items:center;font-size:10px;font-weight:600;padding:3px 10px;border-radius:20px;white-space:nowrap;}

  /* ── MODAL ── */
  .ov{
    position:fixed;inset:0;z-index:300;
    background:rgba(0,0,0,0.82);
    backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);
    display:flex;align-items:flex-end;justify-content:center;
  }
  @media(min-width:600px){.ov{align-items:center;padding:16px;}}
  .ms{
    background:linear-gradient(145deg,#17171e,#0f0f14);
    border:1px solid rgba(255,255,255,0.08);
    border-radius:20px 20px 0 0;
    padding:18px 16px calc(18px + env(safe-area-inset-bottom,0px));
    width:100%;max-height:92vh;
    overflow-y:auto;-webkit-overflow-scrolling:touch;
  }
  @media(min-width:600px){.ms{border-radius:18px;max-width:540px;padding:28px;max-height:88vh;}}
  .mh{width:36px;height:4px;background:rgba(255,255,255,0.1);border-radius:2px;margin:0 auto 16px;}
  @media(min-width:600px){.mh{display:none;}}

  /* ── TABS ── */
  .tabs{display:flex;gap:3px;background:rgba(255,255,255,0.03);border-radius:10px;padding:3px;margin-bottom:16px;}
  .tab{
    flex:1;padding:9px 6px;border:none;cursor:pointer;
    background:transparent;color:#555;font-size:12px;font-weight:500;
    border-radius:8px;transition:all 0.15s;min-height:38px;
    font-family:'DM Sans',sans-serif;
  }
  .tab.on{background:rgba(212,175,55,0.12);color:#D4AF37;font-weight:600;}

  /* ── PROGRESS ── */
  .pt{height:4px;background:rgba(255,255,255,0.05);border-radius:2px;overflow:hidden;}
  .pf{height:100%;border-radius:2px;transition:width 0.4s;}

  /* ── SIDEBAR NAV ── */
  .snav{
    display:flex;align-items:center;gap:10px;
    width:100%;padding:10px 12px;border-radius:8px;
    border:none;cursor:pointer;font-size:13px;
    font-family:'DM Sans',sans-serif;color:#555;font-weight:400;
    margin-bottom:2px;border-left:2px solid transparent;
    text-align:left;transition:all 0.15s;background:none;
    min-height:44px;
  }
  .snav.sg{background:rgba(212,175,55,0.1);color:#D4AF37;border-left-color:#D4AF37;font-weight:600;}
  .snav.sb{background:rgba(52,152,219,0.1);color:#3498DB;border-left-color:#3498DB;font-weight:600;}

  /* ── CHAT ── */
  .chat-wrap{display:flex;flex-direction:column;border-radius:14px;overflow:hidden;border:1px solid rgba(255,255,255,0.08);}
  .chat-msgs{
    flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;
    padding:12px;display:flex;flex-direction:column;gap:8px;
    max-height:52vh;min-height:160px;
  }
  @media(min-width:769px){.chat-msgs{max-height:calc(100vh - 300px);}}
  .chat-in{
    display:flex;gap:8px;padding:10px 12px;
    border-top:1px solid rgba(255,255,255,0.08);align-items:center;flex-shrink:0;
  }
  .chat-field{
    flex:1;background:rgba(255,255,255,0.04);
    border:1px solid rgba(255,255,255,0.08);border-radius:10px;
    padding:10px 12px;color:#eee;font-size:16px;outline:none;
    -webkit-appearance:none;min-height:44px;
    font-family:'DM Sans',sans-serif;
  }
  .chat-field:focus{border-color:rgba(212,175,55,0.35);}

  /* ── HELPERS ── */
  .serif{font-family:'Cormorant Garamond',serif;}
  .gt{background:linear-gradient(135deg,#D4AF37,#F5D76E);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
  .trunc{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  .row-b{display:flex;align-items:flex-start;justify-content:space-between;gap:8px;flex-wrap:wrap;}
  .two-col{display:grid;grid-template-columns:1fr 1fr;gap:10px;}
  .divider{border:none;border-top:1px solid rgba(255,255,255,0.07);margin:14px 0;}
`;

// ─── HELPERS ────────────────────────────────────────────────────────────
const fmtDt = d => d?.toDate ? new Date(d.toDate()).toLocaleString("ro-RO",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"}) : "—";
const today = () => new Date().toISOString().split("T")[0];

// ─── TOAST ──────────────────────────────────────────────────────────────
function Toast({ msg, type, onClose }) {
  useEffect(()=>{ const t=setTimeout(onClose,3800); return()=>clearTimeout(t); },[onClose]);
  const c = {success:"#2ECC71",error:"#E74C3C",info:GOLD}[type]||GOLD;
  return (
    <div style={{position:"fixed",bottom:"calc(72px + env(safe-area-inset-bottom,0px))",left:14,right:14,zIndex:9999,background:"#1c1c22",border:`1px solid ${c}`,borderRadius:12,padding:"12px 14px",fontSize:13,color:"#eee",boxShadow:"0 8px 32px rgba(0,0,0,0.6)",display:"flex",alignItems:"center",gap:10}}>
      <span style={{color:c,fontSize:15,flexShrink:0}}>{type==="success"?"✓":type==="error"?"✕":"◆"}</span>
      <span style={{flex:1}}>{msg}</span>
      <button onClick={onClose} style={{background:"none",border:"none",color:"#444",cursor:"pointer",fontSize:16,flexShrink:0,padding:"2px 4px"}}>✕</button>
    </div>
  );
}

// ─── MODAL ──────────────────────────────────────────────────────────────
function Modal({ open, onClose, children }) {
  if (!open) return null;
  return (
    <div className="ov" onClick={onClose}>
      <div className="ms fu" onClick={e=>e.stopPropagation()}>
        <div className="mh"/>
        {children}
      </div>
    </div>
  );
}

// ─── FIELD ──────────────────────────────────────────────────────────────
function F({ label, multiline, rows=4, children, ...p }) {
  return (
    <div className="f">
      {label && <label>{label}</label>}
      {children ? children
        : multiline ? <textarea className="fi" rows={rows} {...p}/>
        : <input className="fi" {...p}/>}
    </div>
  );
}

// ─── BADGE ──────────────────────────────────────────────────────────────
function Badge({ label, color }) {
  return <span className="badge" style={{background:`${color}22`,color,border:`1px solid ${color}44`}}>{label}</span>;
}

// ─── TOP BAR ────────────────────────────────────────────────────────────
function TopBar({ left, center, right }) {
  const isDesktop = useIsDesktop();
  if (isDesktop) return null;
  return (
    <div className="topbar">
      <div style={{flex:1,minWidth:0}}>{left}</div>
      {center&&<div style={{flexShrink:0}}>{center}</div>}
      <div style={{flexShrink:0}}>{right}</div>
    </div>
  );
}

// ─── BOTTOM NAV ─────────────────────────────────────────────────────────
function BottomNav({ items, active, onChange, onLogout }) {
  const isDesktop = useIsDesktop();
  const scrollRef = React.useRef(null);
  React.useEffect(() => {
    if (!scrollRef.current) return;
    const idx = items.findIndex(it => it.id === active);
    if (idx < 0) return;
    const btn = scrollRef.current.children[idx];
    if (btn) btn.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  }, [active, items]);
  if (isDesktop) return null;
  return (
    <div style={{
      position:"fixed", bottom:0, left:0, right:0, zIndex:100,
      background:"#0d0d10",
      borderTop:"1px solid rgba(255,255,255,0.08)",
      paddingBottom:"env(safe-area-inset-bottom,0px)",
    }}>
      <div ref={scrollRef} style={{
        display:"flex",
        overflowX:"auto",
        overflowY:"hidden",
        WebkitOverflowScrolling:"touch",
        scrollbarWidth:"none",
        msOverflowStyle:"none",
      }}>
        {items.map(it=>(
          <button key={it.id} className={`nb${active===it.id?" on":""}`} onClick={()=>onChange(it.id)}>
            <span className="ni">{it.icon}</span>
            <span className="nl">{it.label}</span>
          </button>
        ))}
        <button className="nb" onClick={onLogout}>
          <span className="ni">⎋</span>
          <span className="nl">Ieși</span>
        </button>
      </div>
    </div>
  );
}

// ─── HOOK DESKTOP ────────────────────────────────────────────────────────
// Detecteaza daca e desktop (>768px) - previne randarea sidebar pe iOS
function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' ? window.innerWidth > 768 : false
  );
  useEffect(()=>{
    const check = () => setIsDesktop(window.innerWidth > 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  },[]);
  return isDesktop;
}

// ─── SIDEBAR ────────────────────────────────────────────────────────────
// IMPORTANT: randat DOAR pe desktop - nu apare deloc pe iOS/Android
function Sidebar({ items, active, onChange, onLogout, user, accent="sg", children }) {
  const isDesktop = useIsDesktop();
  // Pe mobile nu randam nimic - fix definitiv pentru iOS Safari
  if (!isDesktop) return null;
  return (
    <aside style={{
      display:"flex", flexDirection:"column",
      width:220, flexShrink:0,
      background:"linear-gradient(180deg,#0f0f14,#09090c)",
      borderRight:`1px solid ${BORDER}`,
      height:"100vh", position:"sticky", top:0,
      overflowY:"auto", padding:"26px 14px"
    }}>
      <div style={{textAlign:"center",paddingBottom:20,marginBottom:20,borderBottom:`1px solid ${BORDER}`}}>
        <div className="serif gt" style={{fontSize:20,fontWeight:600}}>DJ School</div>
        <div style={{fontSize:9,color:"#333",letterSpacing:3,marginTop:3}}>PRIVILEGE</div>
        {children}
      </div>
      <nav style={{flex:1}}>
        {items.map(it=>(
          <button key={it.id} onClick={()=>onChange(it.id)} className={`snav${active===it.id?" "+accent:""}`}>
            <span>{it.icon}</span>{it.label}
          </button>
        ))}
      </nav>
      <div style={{borderTop:`1px solid ${BORDER}`,paddingTop:12}}>
        <div style={{fontSize:11,color:"#333",paddingLeft:12,marginBottom:8}} className="trunc">{user?.email}</div>
        <button onClick={onLogout} className="snav" style={{color:"#444"}}>⎋ Deconectare</button>
      </div>
    </aside>
  );
}

// ─── QR SCANNER ─────────────────────────────────────────────────────────
function QRScanner({ students, sessions, toast }) {
  const [scanning,setScanning]=useState(false);
  const [result,setResult]=useState(null);
  const [checkinDone,setCheckinDone]=useState(null);
  const [saving,setSaving]=useState(false);
  const ref2=useRef(null);
  const done=useRef(false);

  const start=async()=>{
    setScanning(true);setResult(null);setCheckinDone(null);done.current=false;
    await new Promise(r=>setTimeout(r,400));
    try{
      ref2.current=new Html5Qrcode("qrbox");
      const w=document.getElementById("qrbox")?.offsetWidth||280;
      const box=Math.min(w-48,240);
      await ref2.current.start(
        {facingMode:"environment"},
        {fps:10,qrbox:{width:box,height:box}},
        (decoded)=>{
          if(done.current)return;
          const s=students.find(s=>s.id===decoded||s.uid===decoded);
          if(s){done.current=true;setResult(s);stop();}
          else toast("QR necunoscut.","error");
        },
        ()=>{}
      );
    }catch(e){toast("Camera indisponibilă: "+e.message,"error");setScanning(false);}
  };

  const stop=async()=>{
    try{if(ref2.current){await ref2.current.stop();ref2.current=null;}}catch{}
    setScanning(false);
  };

  useEffect(()=>()=>{stop();},[]);

  const doCheckin=async()=>{
    if(!result)return;
    setSaving(true);
    try{
      const t=today();
      const now=new Date();
      const hhmm=now.getHours().toString().padStart(2,"0")+":"+now.getMinutes().toString().padStart(2,"0");
      let ses=sessions.find(s=>s.studentId===result.id&&s.status==="scheduled"&&s.date===t);
      if(ses){
        await updateDoc(doc(db,"school_sessions",ses.id),{status:"completed",completedAt:serverTimestamp(),checkinAt:serverTimestamp()});
      } else {
        const newRef=doc(collection(db,"school_sessions"));
        await setDoc(newRef,{studentId:result.id,studentName:result.name,mentorId:result.mentorId||null,date:t,time:hhmm,location:"DJ School Studio",status:"completed",notes:"Check-in automat via QR",createdAt:serverTimestamp(),completedAt:serverTimestamp(),checkinAt:serverTimestamp()});
      }
      const snap=await getDoc(doc(db,"school_users",result.id));
      await updateDoc(doc(db,"school_users",result.id),{sessionsCount:(snap.data()?.sessionsCount||0)+1});
      setCheckinDone({name:result.name,time:hhmm});
      setResult(null);
    }catch(e){toast("Eroare check-in: "+e.message,"error");}
    setSaving(false);
  };

  return(
    <div>
      <div id="qrbox" style={{width:"100%",borderRadius:12,overflow:"hidden",background:"#111",marginBottom:12,display:scanning?"block":"none",minHeight:scanning?260:0}}/>
      {!scanning&&!result&&!checkinDone&&(
        <div className="card" style={{textAlign:"center",padding:"40px 20px"}}>
          <div style={{fontSize:56,marginBottom:12}}>⬡</div>
          <div style={{fontSize:15,fontWeight:600,color:"#eee",marginBottom:6}}>Check-in Studio</div>
          <div style={{fontSize:12,color:"#555",marginBottom:24}}>Scanează QR-ul cursantului pentru a înregistra prezența</div>
          <button onClick={start} className="btn gold" style={{padding:"14px 36px",fontSize:14}}>📷 Pornește camera</button>
        </div>
      )}
      {scanning&&<button onClick={stop} className="btn gh-r full" style={{marginTop:8}}>✕ Oprește camera</button>}
      {result&&(
        <div className="card" style={{textAlign:"center",padding:"32px 20px",borderColor:"rgba(212,175,55,0.3)"}}>
          <div style={{width:64,height:64,borderRadius:16,background:`${GOLD}18`,border:`2px solid ${GOLD}44`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,margin:"0 auto 14px",fontFamily:"'Playfair Display',serif",fontWeight:700,color:GOLD}}>{result.name?.charAt(0)}</div>
          <div style={{fontSize:20,fontWeight:700,color:"#eee",marginBottom:4}}>{result.name}</div>
          <div style={{fontSize:12,color:"#555",marginBottom:6}}>{result.email}</div>
          <div style={{fontSize:11,color:"#888",marginBottom:24}}>{sessions.find(s=>s.studentId===result.id&&s.status==="scheduled"&&s.date===today())?"✓ Ședință programată azi — va fi marcată efectuată":"Nu are ședință programată azi — se va crea una nouă"}</div>
          <div style={{display:"flex",gap:10}}>
            <button onClick={doCheckin} disabled={saving} className="btn grn" style={{flex:1,padding:"14px",fontSize:14}}>{saving?"Se procesează...":"✓ Confirmă check-in"}</button>
            <button onClick={()=>setResult(null)} className="btn gh" style={{padding:"14px 18px"}}>✕</button>
          </div>
        </div>
      )}
      {checkinDone&&(
        <div className="card" style={{textAlign:"center",padding:"36px 20px",borderColor:"rgba(46,204,113,0.4)"}}>
          <div style={{fontSize:60,marginBottom:10}}>✓</div>
          <div style={{fontSize:22,fontWeight:700,color:"#2ECC71",marginBottom:6}}>{checkinDone.name}</div>
          <div style={{fontSize:13,color:"#888",marginBottom:6}}>Check-in înregistrat · {checkinDone.time}</div>
          <div style={{fontSize:12,color:"#555",marginBottom:28}}>Ședința a fost marcată ca efectuată.</div>
          <button onClick={()=>{setCheckinDone(null);start();}} className="btn gold full" style={{padding:"13px",fontSize:14}}>📷 Scanează alt cursant</button>
        </div>
      )}
    </div>
  );
}

// ─── STUDENT DETAIL MODAL ────────────────────────────────────────────────
function StudentDetail({ student, sessions, curriculum, mentors, toast }) {
  const [tab,setTab]=useState("progress");
  const ss=sessions.filter(s=>s.studentId===student.id);
  const mentor=mentors.find(m=>m.id===student.mentorId);
  const all=curriculum.reduce((a,m)=>a+(m.lessons||[]).length,0);
  const done=student.completedLessons?.length||0;
  const pct=all>0?Math.round(done/all*100):0;

  const toggle=async(lid)=>{
    const cur=student.completedLessons||[];
    const upd=cur.includes(lid)?cur.filter(l=>l!==lid):[...cur,lid];
    await updateDoc(doc(db,"school_users",student.id),{completedLessons:upd});
    student.completedLessons=upd;
    toast("Progres actualizat!","success");
  };

  return (
    <div>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:14}}>
        <div style={{width:44,height:44,borderRadius:12,background:`${GOLD}18`,border:`1px solid ${GOLD}33`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}} className="serif">{student.name?.charAt(0)}</div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:16,fontWeight:600,color:"#eee"}} className="trunc">{student.name}</div>
          <div style={{fontSize:11,color:"#555"}}>{mentor?.name||"Fără mentor"}</div>
        </div>
        <div style={{textAlign:"right",flexShrink:0}}>
          <div className="serif" style={{fontSize:26,fontWeight:700,color:GOLD}}>{pct}%</div>
        </div>
      </div>
      <div className="pt" style={{marginBottom:16}}><div className="pf" style={{width:`${pct}%`,background:`linear-gradient(90deg,${GOLD},#F5D76E)`}}/></div>
      <div className="tabs">
        {[["progress","Progres"],["sessions","Ședințe"],["videos","Video"]].map(([t,l])=>(
          <button key={t} className={`tab${tab===t?" on":""}`} onClick={()=>setTab(t)}>{l}</button>
        ))}
      </div>
      {tab==="progress"&&(
        <div style={{maxHeight:"50vh",overflowY:"auto",WebkitOverflowScrolling:"touch"}}>
          {curriculum.map((mod,idx)=>(
            <div key={mod.id} style={{marginBottom:14}}>
              <div style={{fontSize:10,color:GOLD,letterSpacing:2,marginBottom:8}}>MODUL {idx+1} · {mod.title}</div>
              {(mod.lessons||[]).map(l=>{
                const d=(student.completedLessons||[]).includes(l.id);
                return (
                  <div key={l.id} onClick={()=>toggle(l.id)} style={{display:"flex",alignItems:"center",gap:10,padding:"10px",borderRadius:8,cursor:"pointer",background:d?"rgba(46,204,113,0.05)":"transparent",border:`1px solid ${d?"rgba(46,204,113,0.2)":BORDER}`,marginBottom:6}}>
                    <div style={{width:22,height:22,borderRadius:6,background:d?"#2ECC71":"rgba(255,255,255,0.05)",border:`1px solid ${d?"#2ECC71":BORDER}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,color:d?"#fff":"#333",flexShrink:0}}>{d?"✓":""}</div>
                    <div style={{fontSize:13,color:d?"#2ECC71":"#aaa",flex:1}}>{l.title}</div>
                    <div style={{fontSize:10,color:"#333",flexShrink:0}}>{l.duration}m</div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      )}
      {tab==="sessions"&&(
        <div style={{maxHeight:"50vh",overflowY:"auto",WebkitOverflowScrolling:"touch"}}>
          {ss.length===0&&<div style={{textAlign:"center",color:"#444",padding:20,fontSize:13}}>Nicio ședință.</div>}
          {ss.map(s=>(
            <div key={s.id} style={{padding:"11px 12px",borderRadius:10,border:`1px solid ${BORDER}`,marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
              <div><div style={{fontSize:13,color:"#eee"}}>{s.date} {s.time}</div><div style={{fontSize:11,color:"#555"}}>{s.location}</div></div>
              <Badge label={s.status==="completed"?"Efectuată":"Programată"} color={s.status==="completed"?"#2ECC71":GOLD}/>
            </div>
          ))}
        </div>
      )}
      {tab==="videos"&&(
        <div style={{maxHeight:"50vh",overflowY:"auto",WebkitOverflowScrolling:"touch"}}>
          {ss.filter(s=>s.videoUrl).map(s=>(
            <div key={s.id} style={{padding:"12px",borderRadius:10,border:`1px solid ${BORDER}`,marginBottom:8}}>
              <div style={{fontSize:11,color:"#555",marginBottom:6}}>{s.date}</div>
              <a href={s.videoUrl} target="_blank" rel="noreferrer" style={{fontSize:13,color:"#3498DB"}}>🎬 Vizionează video</a>
            </div>
          ))}
          {ss.filter(s=>s.videoUrl).length===0&&<div style={{textAlign:"center",color:"#444",padding:20,fontSize:13}}>Niciun video.</div>}
        </div>
      )}
    </div>
  );
}

// ─── BOOKING INTEGRATION ────────────────────────────────────────────────
// Citeste programarile confirmate din booking.privilegeagency.eu (Firestore comun)
// BOOKING INTEGRATION
// Colectia: "bookings" (din privilege-booking, acelasi Firestore)
// Campuri relevante: email, name, date, time, status:"confirmed", service:"djschool"
// Cursant: cauta dupa email (user.email) + status confirmed + service djschool
// Mentor: nu are camp direct — vede toate programarile djschool confirmate
function useBookingAppointments(userEmail, role) {
  const [appointments, setAppointments] = useState([]);
  useEffect(()=>{
    if(!userEmail) return;
    let q;
    if(role==="student"){
      // Cauta programarile confirmate ale acestui email pentru serviciul djschool
      q=query(
        collection(db,"bookings"),
        where("status","==","confirmed"),
        where("service","==","djschool"),
        where("email","==",userEmail),
        orderBy("date","desc"),
        limit(30)
      );
    } else if(role==="mentor"){
      // Mentorul vede toate programarile djschool confirmate
      q=query(
        collection(db,"bookings"),
        where("status","==","confirmed"),
        where("service","==","djschool"),
        orderBy("date","desc"),
        limit(50)
      );
    } else {
      return;
    }
    const unsub=onSnapshot(q, snap=>{
      setAppointments(snap.docs.map(d=>({id:d.id,...d.data()})));
    }, (err)=>{
      // Daca lipseste index Firestore, fallback fara orderBy
      console.warn("Booking query err:",err.message);
      const q2 = role==="student"
        ? query(collection(db,"bookings"),where("status","==","confirmed"),where("service","==","djschool"),where("email","==",userEmail),limit(30))
        : query(collection(db,"bookings"),where("status","==","confirmed"),where("service","==","djschool"),limit(50));
      onSnapshot(q2, snap2=>{
        const sorted=snap2.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>(b.date||"").localeCompare(a.date||""));
        setAppointments(sorted);
      }, ()=>{});
    });
    return()=>unsub();
  },[userEmail,role]);
  return appointments;
}

// ════════════════════════════════════════════════
// LOGIN
// ════════════════════════════════════════════════
function LoginPage({ onLogin, toast }) {
  const [role,setRole]=useState(null);
  const [email,setEmail]=useState("");
  const [pass,setPass]=useState("");
  const [loading,setLoading]=useState(false);

  const roles={
    admin:  {label:"Administrator",icon:"◆", color:GOLD,     desc:"Acces complet la platforma DJ School"},
    mentor: {label:"Mentor",       icon:"🎧",color:"#3498DB",desc:"Dashboard mentor – cursanți & ședințe"},
    student:{label:"Cursant",      icon:"✦", color:"#2ECC71",desc:"Portalul tău de learning DJ"},
  };

  const handleLogin=async()=>{
    if(!email||!pass)return;
    setLoading(true);
    try{
      const snap=await getDocs(collection(db,"school_users"));
      const ud=snap.docs.find(d=>d.data().email?.trim().toLowerCase()===email.trim().toLowerCase());
      if(!ud){toast("Email negăsit.","error");setLoading(false);return;}
      const data=ud.data();
      if(data.password!==pass){toast("Parolă greșită.","error");setLoading(false);return;}
      if(role&&data.role!==role){toast(`Cont de tip ${data.role}.`,"error");setLoading(false);return;}
      if(!data.active){toast("Cont inactiv.","error");setLoading(false);return;}
      const session={uid:ud.id,...data};
      localStorage.setItem("school_session",JSON.stringify(session));
      onLogin(session);
    }catch(e){toast("Eroare: "+e.message,"error");}
    setLoading(false);
  };

  return (
    <div style={{minHeight:"100vh",background:DARK,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px 16px"}}>
      <style>{CSS}</style>
      <div className="fu" style={{width:"100%",maxWidth:400}}>
        <div style={{textAlign:"center",marginBottom:36}}>
          <div style={{fontSize:11,color:"#444",letterSpacing:4,marginBottom:8}}>PRIVILEGE AGENCY</div>
          <div className="serif gt" style={{fontSize:34,fontWeight:600}}>DJ School</div>
          <div style={{fontSize:11,color:"#333",marginTop:6,letterSpacing:2}}>LEARNING PLATFORM</div>
        </div>
        {!role?(
          <>
            <div style={{fontSize:12,color:"#444",textAlign:"center",marginBottom:14}}>Selectează tipul de cont</div>
            {Object.entries(roles).map(([key,cfg])=>(
              <button key={key} onClick={()=>setRole(key)} style={{width:"100%",background:"rgba(255,255,255,0.03)",border:`1px solid ${BORDER}`,borderRadius:14,padding:"16px",cursor:"pointer",display:"flex",alignItems:"center",gap:14,marginBottom:10,minHeight:72}}>
                <div style={{width:44,height:44,borderRadius:12,background:`${cfg.color}18`,border:`1px solid ${cfg.color}33`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>{cfg.icon}</div>
                <div style={{textAlign:"left",flex:1,minWidth:0}}>
                  <div style={{fontSize:15,fontWeight:600,color:"#eee"}}>{cfg.label}</div>
                  <div style={{fontSize:12,color:"#555",marginTop:2}}>{cfg.desc}</div>
                </div>
                <div style={{color:"#333",fontSize:20,flexShrink:0}}>›</div>
              </button>
            ))}
          </>
        ):(
          <div className="card">
            <button onClick={()=>{setRole(null);setEmail("");setPass("");}} style={{background:"none",border:"none",color:"#555",fontSize:13,cursor:"pointer",marginBottom:16,display:"flex",alignItems:"center",gap:6}}>‹ Înapoi</button>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
              <div style={{width:40,height:40,borderRadius:10,background:`${roles[role].color}18`,border:`1px solid ${roles[role].color}33`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{roles[role].icon}</div>
              <div>
                <div style={{fontSize:16,fontWeight:600,color:"#eee"}}>{roles[role].label}</div>
                <div style={{fontSize:11,color:"#555"}}>Autentificare</div>
              </div>
            </div>
            <F label="Email" type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="email@example.com"/>
            <F label="Parolă" type="password" value={pass} onChange={e=>setPass(e.target.value)} placeholder="••••••••" onKeyDown={e=>e.key==="Enter"&&handleLogin()}/>
            <button onClick={handleLogin} disabled={loading} className="btn full" style={{background:`linear-gradient(135deg,${roles[role].color},${roles[role].color}cc)`,color:role==="admin"?"#0a0a0d":"#fff"}}>
              {loading?"Se conectează...":"Intră în cont"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════
// ADMIN DASHBOARD
// ════════════════════════════════════════════════
function AdminDashboard({ user, onLogout, toast }) {
  const [view,setView]=useState("overview");
  const [students,setStudents]=useState([]);
  const [mentors,setMentors]=useState([]);
  const [sessions,setSessions]=useState([]);
  const [curriculum,setCurriculum]=useState([]);
  const [saving,setSaving]=useState(false);
  const [M,setM]=useState({});
  const open=k=>setM(m=>({...m,[k]:true}));
  const close=k=>setM(m=>({...m,[k]:false}));

  const [sF,setSF]=useState({name:"",email:"",phone:"",mentorId:"",package:"",startDate:"",notes:""});
  const [mF,setMF]=useState({name:"",email:"",phone:"",bio:""});
  const [modF,setModF]=useState({title:"",titleEn:"",description:""});
  const [lesF,setLesF]=useState({title:"",titleEn:"",description:"",duration:60});
  const [seF,setSeF]=useState({studentId:"",mentorId:"",date:"",time:"",location:"DJ School Studio",notes:"",videoUrl:""});
  const [lesFor,setLesFor]=useState(null);
  const [editMod,setEditMod]=useState(null);
  const [editModF,setEditModF]=useState({title:"",titleEn:"",description:""});
  const [editLes,setEditLes]=useState(null);
  const [editLesF,setEditLesF]=useState({title:"",titleEn:"",description:"",duration:60});
  const [cred,setCred]=useState(null);
  const [detail,setDetail]=useState(null);
  const [qrMod,setQrMod]=useState(null);
  const [delConfirm,setDelConfirm]=useState(null);
  const [resetConfirm,setResetConfirm]=useState(null);

  // JURNAL + RESURSE
  const [jurnalSes,setJurnalSes]=useState(null);
  const [jurnalF,setJurnalF]=useState({mentorFeedback:"",tasksCasa:"",observatii:""});
  const [jurnalSaving,setJurnalSaving]=useState(false);
  const [resources,setResources]=useState([]);
  const [resF,setResF]=useState({title:"",description:"",lessonNumber:"",type:"pdf",url:""});
  const [resFile,setResFile]=useState(null);
  const [resUploading,setResUploading]=useState(false);

  const saveJurnal=async()=>{
    if(!jurnalSes)return;
    setJurnalSaving(true);
    try{
      await updateDoc(doc(db,"school_sessions",jurnalSes.id),{
        mentorFeedback:jurnalF.mentorFeedback,
        tasksCasa:jurnalF.tasksCasa,
        observatii:jurnalF.observatii,
        jurnalUpdatedAt:serverTimestamp(),
      });
      toast("Jurnal salvat!","success");
      setJurnalSes(null);
    }catch(e){toast("Eroare: "+e.message,"error");}
    setJurnalSaving(false);
  };

  const saveResource=async()=>{
    if(!resF.title){toast("Titlu obligatoriu.","error");return;}
    setResUploading(true);
    try{
      let url=resF.url;
      if(resFile){
        const r=ref(storage,"school_resources/"+Date.now()+"_"+resFile.name);
        await uploadBytes(r,resFile);
        url=await getDownloadURL(r);
      }
      await addDoc(collection(db,"school_resources"),{
        ...resF,
        lessonNumber:Number(resF.lessonNumber)||0,
        url,
        createdAt:serverTimestamp(),
      });
      setResF({title:"",description:"",lessonNumber:"",type:"pdf",url:""});
      setResFile(null);
      close("addRes");
      toast("Resursa adaugata!","success");
    }catch(e){toast("Eroare: "+e.message,"error");}
    setResUploading(false);
  };

  useEffect(()=>{
    const u5=onSnapshot(query(collection(db,"school_resources"),orderBy("lessonNumber","asc")),s=>setResources(s.docs.map(d=>({id:d.id,...d.data()}))));
    const u1=onSnapshot(query(collection(db,"school_users"),where("role","==","student"),orderBy("createdAt","desc")),s=>setStudents(s.docs.map(d=>({id:d.id,...d.data()}))));
    const u2=onSnapshot(query(collection(db,"school_users"),where("role","==","mentor")),s=>setMentors(s.docs.map(d=>({id:d.id,...d.data()}))));
    const u3=onSnapshot(query(collection(db,"school_sessions"),orderBy("date","desc")),s=>setSessions(s.docs.map(d=>({id:d.id,...d.data()}))));
    const u4=onSnapshot(query(collection(db,"school_curriculum"),orderBy("order","asc")),s=>setCurriculum(s.docs.map(d=>({id:d.id,...d.data()}))));
    return()=>{u1();u2();u3();u4();u5();};
  },[]);

  const mkStudent=async()=>{
    if(!sF.name||!sF.email){toast("Nume și email obligatorii.","error");return;}
    setSaving(true);
    try{
      const pass="School"+Math.floor(Math.random()*9000+1000)+"!";
      const r=doc(collection(db,"school_users"));
      await setDoc(r,{...sF,email:sF.email.trim().toLowerCase(),password:pass,role:"student",uid:r.id,active:true,createdAt:serverTimestamp(),completedLessons:[],sessionsCount:0});
      setCred({name:sF.name,email:sF.email.trim().toLowerCase(),password:pass,role:"student"});
      setSF({name:"",email:"",phone:"",mentorId:"",package:"",startDate:"",notes:""});
      close("addS");toast("Cursant creat!","success");
    }catch(e){toast("Eroare: "+e.message,"error");}
    setSaving(false);
  };

  const mkMentor=async()=>{
    if(!mF.name||!mF.email){toast("Nume și email obligatorii.","error");return;}
    setSaving(true);
    try{
      const pass="Mentor"+Math.floor(Math.random()*9000+1000)+"!";
      const r=doc(collection(db,"school_users"));
      await setDoc(r,{...mF,email:mF.email.trim().toLowerCase(),password:pass,role:"mentor",uid:r.id,active:true,createdAt:serverTimestamp()});
      setCred({name:mF.name,email:mF.email.trim().toLowerCase(),password:pass,role:"mentor"});
      setMF({name:"",email:"",phone:"",bio:""});
      close("addM");toast("Mentor creat!","success");
    }catch(e){toast("Eroare: "+e.message,"error");}
    setSaving(false);
  };

  const mkSession=async()=>{
    if(!seF.studentId||!seF.date){toast("Cursant și dată obligatorii.","error");return;}
    setSaving(true);
    await addDoc(collection(db,"school_sessions"),{...seF,status:"scheduled",createdAt:serverTimestamp()});
    setSeF({studentId:"",mentorId:"",date:"",time:"",location:"DJ School Studio",notes:"",videoUrl:""});
    close("addSe");toast("Ședință programată!","success");
    setSaving(false);
  };

  const markDone=async(sid,stid)=>{
    await updateDoc(doc(db,"school_sessions",sid),{status:"completed",completedAt:serverTimestamp()});
    const snap=await getDoc(doc(db,"school_users",stid));
    await updateDoc(doc(db,"school_users",stid),{sessionsCount:(snap.data()?.sessionsCount||0)+1});
    toast("Ședință efectuată!","success");
  };

  // ȘTERGERE CONT — șterge documentul și toate datele asociate
  const deleteAccount=async()=>{
    if(!delConfirm)return;
    setSaving(true);
    try{
      // Stergem sesiunile asociate
      const sesSnap=await getDocs(query(collection(db,"school_sessions"),where("studentId","==",delConfirm.id)));
      for(const d of sesSnap.docs) await deleteDoc(d.ref);
      // Stergem documentul user
      await deleteDoc(doc(db,"school_users",delConfirm.id));
      toast(`Cont ${delConfirm.name} șters.`,"success");
      setDelConfirm(null);
    }catch(e){toast("Eroare ștergere: "+e.message,"error");}
    setSaving(false);
  };

  // Toggle activ/inactiv
  const toggleActive=async(u2)=>{
    await updateDoc(doc(db,"school_users",u2.id),{active:!u2.active});
    toast(u2.active?"Cont dezactivat.":"Cont activat.","info");
  };

  const resetStudent=async()=>{
    if(!resetConfirm)return;
    setSaving(true);
    try{
      const sesSnap=await getDocs(query(collection(db,"school_sessions"),where("studentId","==",resetConfirm.id)));
      for(const d of sesSnap.docs) await deleteDoc(d.ref);
      const vidSnap=await getDocs(query(collection(db,"school_student_videos"),where("studentId","==",resetConfirm.id)));
      for(const d of vidSnap.docs) await deleteDoc(d.ref);
      await updateDoc(doc(db,"school_users",resetConfirm.id),{completedLessons:[],sessionsCount:0});
      toast(`✓ ${resetConfirm.name} resetat complet.`,"success");
      setResetConfirm(null);
    }catch(e){toast("Eroare reset: "+e.message,"error");}
    setSaving(false);
  };

  const updateMod=async(modId,modF)=>{
    await updateDoc(doc(db,"school_curriculum",modId),modF);
    toast("Modul actualizat!","success");
  };

  const updateLes=async(modId,lesIdx,lesF)=>{
    const snap=await getDoc(doc(db,"school_curriculum",modId));
    const lessons=[...(snap.data().lessons||[])];
    lessons[lesIdx]={...lessons[lesIdx],...lesF,duration:parseInt(lesF.duration)||60};
    await updateDoc(doc(db,"school_curriculum",modId),{lessons});
    toast("Lecție actualizată!","success");
  };

  const deleteLes=async(modId,lesIdx)=>{
    const snap=await getDoc(doc(db,"school_curriculum",modId));
    const lessons=[...(snap.data().lessons||[])];
    lessons.splice(lesIdx,1);
    await updateDoc(doc(db,"school_curriculum",modId),{lessons});
    toast("Lecție ștearsă.","info");
  };

  const genQR=async(student)=>{
    const canvas=document.createElement("canvas");
    await QRCode.toCanvas(canvas,student.uid||student.id,{width:300,margin:2,color:{dark:"#D4AF37",light:"#09090c"}});
    setQrMod({student,qr:canvas.toDataURL()});
  };

  const importCurr=async()=>{
    if(!window.confirm("Importă programa oficială? Modulele existente vor fi înlocuite."))return;
    setSaving(true);
    try{
      const MODS=[
        {order:0,title:"Fundamentele Absolute",titleEn:"Absolute Fundamentals",lessons:[{id:"s1_l1",title:"Rolul DJ-ului",duration:30,session:1},{id:"s1_l2",title:"Pornire corectă & Setare CUE",duration:90,session:1,practical:true}]},
        {order:1,title:"BPM, Tempo & Timing",titleEn:"BPM, Tempo & Timing",lessons:[{id:"s2_l1",title:"BPM real vs BPM simțit",duration:30,session:2},{id:"s2_l2",title:"Ajustare pitch & Aliniere drop-uri",duration:90,session:2,practical:true}]},
        {order:2,title:"Mixerul & Controlul Sunetului",titleEn:"Mixer & Sound Control",lessons:[{id:"s3_l1",title:"Gain Staging & EQ",duration:30,session:3},{id:"s3_l2",title:"Mix din EQ & Tăieri curate",duration:90,session:3,practical:true}]},
        {order:3,title:"Muzica DJ-ului (Rekordbox)",titleEn:"DJ Music Management",lessons:[{id:"s4_l1",title:"Analiza piesei & Grid",duration:30,session:4},{id:"s4_l2",title:"Hot Cues, Memory Points & Mini-set",duration:90,session:4,practical:true}]},
        {order:4,title:"Tranziții",titleEn:"Transitions",lessons:[{id:"s5_l1",title:"Tipuri de tranziții",duration:30,session:5},{id:"s5_l2",title:"Long mix, Cut & Filter",duration:90,session:5,practical:true}]},
        {order:5,title:"Beatmatching Manual",titleEn:"Manual Beatmatching",lessons:[{id:"s6_l1",title:"De ce sync e unealtă, nu cârjă",duration:30,session:6},{id:"s6_l2",title:"Mix manual Sync OFF",duration:90,session:6,practical:true}]},
        {order:6,title:"FX — DJM-A9",titleEn:"FX — DJM-A9",lessons:[{id:"s7_l1",title:"Color FX vs Beat FX",duration:30,session:7},{id:"s7_l2",title:"Echo out & FX pe breakdown",duration:90,session:7,practical:true}]},
        {order:7,title:"Flow & Energie",titleEn:"Flow & Energy",lessons:[{id:"s8_l1",title:"Structura unui set",duration:30,session:8},{id:"s8_l2",title:"Mini-set coerent & Mixaj armonic",duration:90,session:8,practical:true}]},
        {order:8,title:"Set de 30 Minute",titleEn:"30-Minute Set",lessons:[{id:"s9_l1",title:"Set autonom 30 min",duration:120,session:9,practical:true}]},
        {order:9,title:"Simulare Club",titleEn:"Club Simulation",lessons:[{id:"s10_l1",title:"Greșeli simulate & Management stres",duration:120,session:10,practical:true}]},
        {order:10,title:"Set Final 45-60 min",titleEn:"Final Set 45-60 min",lessons:[{id:"s11_l1",title:"Set complet 45-60 min",duration:120,session:11,practical:true}]},
        {order:11,title:"Evaluare & Direcție",titleEn:"Evaluation & Direction",lessons:[{id:"s12_l1",title:"Feedback final & Pași următori",duration:120,session:12}]},
      ];
      const ex=await getDocs(collection(db,"school_curriculum"));
      for(const d of ex.docs)await deleteDoc(d.ref);
      for(const m of MODS)await addDoc(collection(db,"school_curriculum"),{...m,createdAt:serverTimestamp()});
      toast("12 module importate!","success");
    }catch(e){toast("Eroare: "+e.message,"error");}
    setSaving(false);
  };

  const navItems=[
    {id:"overview",  icon:"◆",  label:"Overview"},
    {id:"students",  icon:"✦",  label:"Cursanți"},
    {id:"mentors",   icon:"🎧", label:"Mentori"},
    {id:"sessions",  icon:"📅", label:"Ședințe"},
    {id:"curriculum",icon:"📋", label:"Programă"},
    {id:"scan",      icon:"⬡",  label:"Scan QR"},
    {id:"jurnal",    icon:"📓", label:"Jurnal"},
    {id:"resurse",   icon:"📚", label:"Resurse"},
  ];

  const stats=[
    {label:"Cursanți activi",value:students.filter(s=>s.active).length,color:GOLD},
    {label:"Mentori",        value:mentors.length,                      color:"#3498DB"},
    {label:"Ședințe azi",    value:sessions.filter(s=>s.date===today()).length,color:"#2ECC71"},
    {label:"Efectuate",      value:sessions.filter(s=>s.status==="completed").length,color:"#9B59B6"},
  ];

  return (
    <div className="shell" style={{background:DARK}}>
      <style>{CSS}</style>
      <TopBar
        left={<div><div className="serif gt" style={{fontSize:17,fontWeight:600}}>DJ School</div><div style={{fontSize:9,color:"#333",letterSpacing:2}}>ADMIN</div></div>}
        right={<button onClick={onLogout} className="btn gh sm">⎋ Ieși</button>}
      />
      <Sidebar items={navItems} active={view} onChange={setView} onLogout={onLogout} user={user} accent="sg"/>

      <div className="scroll fu">

        {/* OVERVIEW */}
        {view==="overview"&&(
          <>
            <div className="serif gt" style={{fontSize:22,fontWeight:600,marginBottom:4}}>Bun venit, Admin</div>
            <div style={{fontSize:12,color:"#444",marginBottom:16}}>Privilege DJ School</div>
            <div className="sg">
              {stats.map(s=>(
                <div key={s.label} className="card">
                  <div className="serif" style={{fontSize:30,fontWeight:700,color:s.color}}>{s.value}</div>
                  <div style={{fontSize:11,color:"#555",marginTop:4}}>{s.label}</div>
                </div>
              ))}
            </div>
            <div style={{fontSize:13,fontWeight:600,color:"#eee",marginBottom:10}}>Ședințe recente</div>
            {sessions.slice(0,5).map(s=>{
              const st=students.find(x=>x.id===s.studentId);
              const me=mentors.find(x=>x.id===s.mentorId);
              return (
                <div key={s.id} className="card" style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:8,padding:"12px 14px"}}>
                  <div style={{minWidth:0}}>
                    <div style={{fontSize:13,fontWeight:600,color:"#eee"}} className="trunc">{st?.name||"—"}</div>
                    <div style={{fontSize:11,color:"#555"}}>{s.date} · {me?.name||"—"}</div>
                  </div>
                  <Badge label={s.status==="completed"?"Efectuată":s.status==="cancelled"?"Anulată":"Programată"} color={s.status==="completed"?"#2ECC71":s.status==="cancelled"?"#E74C3C":GOLD}/>
                </div>
              );
            })}
            {sessions.length===0&&<div style={{textAlign:"center",color:"#444",padding:30,fontSize:13}}>Nicio ședință.</div>}
          </>
        )}

        {/* CURSANȚI */}
        {view==="students"&&(
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,gap:8,flexWrap:"wrap"}}>
              <div className="serif" style={{fontSize:22,color:GOLD}}>✦ Cursanți</div>
              <button onClick={()=>open("addS")} className="btn gold sm">+ Cursant</button>
            </div>
            {students.map(s=>{
              const mentor=mentors.find(m=>m.id===s.mentorId);
              const done=sessions.filter(x=>x.studentId===s.id&&x.status==="completed").length;
              return (
                <div key={s.id} className="card" style={{cursor:"pointer"}} onClick={()=>setDetail(s)}>
                  <div style={{display:"flex",alignItems:"center",gap:12}}>
                    <div style={{width:42,height:42,borderRadius:12,background:`${GOLD}18`,border:`1px solid ${GOLD}33`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}} className="serif">{s.name?.charAt(0)}</div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:14,fontWeight:600,color:"#eee"}} className="trunc">{s.name}</div>
                      <div style={{fontSize:11,color:"#555"}}>{mentor?.name||"Fără mentor"} · {done} ședințe</div>
                    </div>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:6,flexShrink:0}}>
                      <Badge label={s.active?"Activ":"Inactiv"} color={s.active?"#2ECC71":"#E74C3C"}/>
                      <div style={{display:"flex",gap:6}}>
                        <button onClick={e=>{e.stopPropagation();genQR(s);}} className="btn gh-b sm">QR</button>
                        <button onClick={e=>{e.stopPropagation();toggleActive(s);}} className="btn gh sm">{s.active?"Dezact.":"Activ."}</button>
                        <button onClick={e=>{e.stopPropagation();setResetConfirm({id:s.id,name:s.name});}} className="btn gh sm" style={{color:"#F39C12",borderColor:"rgba(243,156,18,0.3)"}}>🔄</button>
                        <button onClick={e=>{e.stopPropagation();setDelConfirm({id:s.id,name:s.name,role:"student"});}} className="btn gh-r sm">🗑</button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            {students.length===0&&<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Niciun cursant.</div>}
          </>
        )}

        {/* MENTORI */}
        {view==="mentors"&&(
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,gap:8,flexWrap:"wrap"}}>
              <div className="serif" style={{fontSize:22,color:"#3498DB"}}>🎧 Mentori</div>
              <button onClick={()=>open("addM")} className="btn blue sm">+ Mentor</button>
            </div>
            {mentors.map(m=>(
              <div key={m.id} className="card">
                <div style={{display:"flex",alignItems:"center",gap:12}}>
                  <div style={{width:42,height:42,borderRadius:12,background:"rgba(52,152,219,0.12)",border:"1px solid rgba(52,152,219,0.2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>🎧</div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:14,fontWeight:600,color:"#eee"}}>{m.name}</div>
                    <div style={{fontSize:11,color:"#555"}} className="trunc">{m.email} · {students.filter(s=>s.mentorId===m.id).length} cursanți</div>
                    {m.bio&&<div style={{fontSize:12,color:"#666",marginTop:4}}>{m.bio}</div>}
                  </div>
                  <div style={{display:"flex",flexDirection:"column",gap:6,flexShrink:0}}>
                    <button onClick={()=>toggleActive(m)} className="btn gh sm">{m.active?"Dezact.":"Activ."}</button>
                    <button onClick={()=>setDelConfirm({id:m.id,name:m.name,role:"mentor"})} className="btn gh-r sm">🗑</button>
                  </div>
                </div>
              </div>
            ))}
            {mentors.length===0&&<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Niciun mentor.</div>}
          </>
        )}

        {/* ȘEDINȚE */}
        {view==="sessions"&&(
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,gap:8,flexWrap:"wrap"}}>
              <div className="serif" style={{fontSize:22,color:"#2ECC71"}}>📅 Ședințe</div>
              <button onClick={()=>open("addSe")} className="btn grn sm">+ Ședință</button>
            </div>
            {sessions.map(s=>{
              const st=students.find(x=>x.id===s.studentId);
              const me=mentors.find(x=>x.id===s.mentorId);
              return (
                <div key={s.id} className="card" style={{borderColor:s.status==="completed"?"rgba(46,204,113,0.2)":BORDER}}>
                  <div className="row-b">
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:14,fontWeight:600,color:"#eee"}}>{st?.name||"—"}</div>
                      <div style={{fontSize:11,color:"#666",marginTop:2}}>{s.date} {s.time} · {me?.name||"—"}</div>
                      {s.videoUrl&&<a href={s.videoUrl} target="_blank" rel="noreferrer" style={{fontSize:11,color:"#3498DB",display:"block",marginTop:4}}>🎬 Video</a>}
                      {s.source==="booking"&&<div style={{fontSize:10,color:GOLD,marginTop:3}}>📌 Booking App</div>}
                    </div>
                    <div style={{display:"flex",flexDirection:"column",gap:6,alignItems:"flex-end",flexShrink:0}}>
                      <Badge label={s.status==="completed"?"Efectuată":s.status==="cancelled"?"Anulată":"Programată"} color={s.status==="completed"?"#2ECC71":s.status==="cancelled"?"#E74C3C":GOLD}/>
                      {s.status==="scheduled"&&(
                        <div style={{display:"flex",gap:5}}>
                          <button onClick={()=>markDone(s.id,s.studentId)} style={{padding:"5px 10px",borderRadius:7,background:"rgba(46,204,113,0.1)",border:"1px solid rgba(46,204,113,0.25)",color:"#2ECC71",fontSize:11,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",minHeight:32}}>✓</button>
                          <button onClick={async()=>{const url=prompt("Link video:");if(url){await updateDoc(doc(db,"school_sessions",s.id),{videoUrl:url});toast("Video adăugat!","success");}}} className="btn gh-b sm">🎬</button>
                          <button onClick={async()=>{if(window.confirm("Ștergi ședința?"))await deleteDoc(doc(db,"school_sessions",s.id));}} className="btn gh-r sm">🗑</button>
                        </div>
                      )}
                      {s.status==="completed"&&(
                        <button onClick={()=>{setJurnalSes(s);setJurnalF({mentorFeedback:s.mentorFeedback||"",tasksCasa:s.tasksCasa||"",observatii:s.observatii||""});open("jurnal");}} className="btn gh sm" style={{fontSize:10}}>
                          {s.mentorFeedback?"📓 Edit jurnal":"📓 Jurnal"}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
            {sessions.length===0&&<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Nicio ședință.</div>}
          </>
        )}

        {/* PROGRAMĂ */}
        {view==="curriculum"&&(
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,gap:8,flexWrap:"wrap"}}>
              <div className="serif" style={{fontSize:22,color:GOLD}}>📋 Programă</div>
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                <button onClick={importCurr} disabled={saving} className="btn gh-g sm">⬇ Import</button>
                <button onClick={()=>open("addMod")} className="btn gold sm">+ Modul</button>
              </div>
            </div>
            {curriculum.map((mod,idx)=>(
              <div key={mod.id} className="card">
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:(mod.lessons||[]).length?10:0}}>
                  <div style={{flex:1,minWidth:0,marginRight:8}}>
                    <div style={{fontSize:10,color:GOLD,letterSpacing:2}}>MODUL {idx+1}</div>
                    <div style={{fontSize:14,fontWeight:600,color:"#eee",marginTop:2}}>{mod.title}</div>
                    {mod.titleEn&&<div style={{fontSize:11,color:"#555",marginTop:1}}>{mod.titleEn}</div>}
                  </div>
                  <div style={{display:"flex",gap:5,flexShrink:0}}>
                    <button onClick={()=>{setEditMod({id:mod.id});setEditModF({title:mod.title||"",titleEn:mod.titleEn||"",description:mod.description||""});}} className="btn gh-g sm">✏️</button>
                    <button onClick={()=>setLesFor(mod.id)} className="btn gh-g sm">+Lecție</button>
                    <button onClick={async()=>{if(window.confirm("Ștergi modulul și toate lecțiile din el?")){await deleteDoc(doc(db,"school_curriculum",mod.id));toast("Șters.","info");}}} className="btn gh-r sm">🗑</button>
                  </div>
                </div>
                {(mod.lessons||[]).map((l,li)=>(
                  <div key={l.id} style={{display:"flex",alignItems:"center",gap:8,padding:"9px 0",borderTop:`1px solid ${BORDER}`}}>
                    <div style={{width:22,height:22,borderRadius:6,background:`${GOLD}14`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,color:GOLD,fontWeight:700,flexShrink:0}}>{li+1}</div>
                    <div style={{fontSize:13,color:"#ccc",flex:1,minWidth:0}}>
                      <div className="trunc">{l.title}</div>
                      {l.description&&<div style={{fontSize:11,color:"#555",marginTop:1}} className="trunc">{l.description}</div>}
                    </div>
                    <div style={{fontSize:10,color:"#555",flexShrink:0}}>{l.duration}m</div>
                    <div style={{display:"flex",gap:4,flexShrink:0}}>
                      <button onClick={()=>{setEditLes({modId:mod.id,lesIdx:li});setEditLesF({title:l.title||"",titleEn:l.titleEn||"",description:l.description||"",duration:l.duration||60});}} className="btn gh-g sm" style={{minHeight:28,padding:"4px 8px",fontSize:11}}>✏️</button>
                      <button onClick={()=>{if(window.confirm(`Ștergi lecția "${l.title}"?`))deleteLes(mod.id,li);}} className="btn gh-r sm" style={{minHeight:28,padding:"4px 8px",fontSize:11}}>🗑</button>
                    </div>
                  </div>
                ))}
                {(mod.lessons||[]).length===0&&<div style={{fontSize:11,color:"#333",fontStyle:"italic",padding:"8px 0"}}>Nicio lecție adăugată</div>}
              </div>
            ))}
            {curriculum.length===0&&<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Programa goală. Importă sau adaugă module.</div>}
          </>
        )}

        {/* SCAN QR */}
        {view==="scan"&&(
          <>
            <div className="serif" style={{fontSize:22,color:GOLD,marginBottom:16}}>⬡ Scan QR</div>
            <QRScanner students={students} sessions={sessions} toast={toast}/>
          </>
        )}

        {/* JURNAL SEDINTE */}
        {view==="jurnal"&&(
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,gap:8,flexWrap:"wrap"}}>
              <div className="serif" style={{fontSize:22,color:GOLD}}>📓 Jurnal Ședințe</div>
            </div>
            {sessions.filter(s=>s.status==="completed").map(s=>{
              const st=students.find(x=>x.id===s.studentId);
              const hasJurnal=s.mentorFeedback||s.tasksCasa;
              return(
                <div key={s.id} className="card" style={{borderColor:hasJurnal?"rgba(46,204,113,0.25)":BORDER}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
                    <div style={{flex:1}}>
                      <div style={{fontSize:13,fontWeight:600,color:"#eee"}}>{st?.name||"Cursant"}</div>
                      <div style={{fontSize:11,color:"#555",marginTop:2}}>{s.date} · {s.time} · {s.location}</div>
                      {hasJurnal&&(
                        <div style={{marginTop:10,display:"flex",flexDirection:"column",gap:8}}>
                          {s.mentorFeedback&&(
                            <div style={{background:"rgba(46,204,113,0.05)",border:"1px solid rgba(46,204,113,0.15)",borderRadius:8,padding:"8px 12px"}}>
                              <div style={{fontSize:9,color:"#2ECC71",letterSpacing:2,marginBottom:4}}>FEEDBACK MENTOR</div>
                              <div style={{fontSize:12,color:"#ccc",lineHeight:1.6}}>{s.mentorFeedback}</div>
                            </div>
                          )}
                          {s.tasksCasa&&(
                            <div style={{background:"rgba(212,175,55,0.05)",border:"1px solid rgba(212,175,55,0.15)",borderRadius:8,padding:"8px 12px"}}>
                              <div style={{fontSize:9,color:GOLD,letterSpacing:2,marginBottom:4}}>TASKURI ACASA</div>
                              <div style={{fontSize:12,color:"#ccc",lineHeight:1.6}}>{s.tasksCasa}</div>
                            </div>
                          )}
                          {s.observatii&&(
                            <div style={{background:"rgba(52,152,219,0.05)",border:"1px solid rgba(52,152,219,0.15)",borderRadius:8,padding:"8px 12px"}}>
                              <div style={{fontSize:9,color:"#3498DB",letterSpacing:2,marginBottom:4}}>NOTE INTERNE</div>
                              <div style={{fontSize:12,color:"#ccc",lineHeight:1.6}}>{s.observatii}</div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <button onClick={()=>{setJurnalSes(s);setJurnalF({mentorFeedback:s.mentorFeedback||"",tasksCasa:s.tasksCasa||"",observatii:s.observatii||""}); open("jurnal");}} className="btn gh sm" style={{flexShrink:0}}>
                      {hasJurnal?"✏️ Edit":"📝 Adaugă"}
                    </button>
                  </div>
                </div>
              );
            })}
            {sessions.filter(s=>s.status==="completed").length===0&&(
              <div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Nicio ședință efectuată încă.</div>
            )}
          </>
        )}

        {/* RESURSE */}
        {view==="resurse"&&(
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,gap:8,flexWrap:"wrap"}}>
              <div className="serif" style={{fontSize:22,color:GOLD}}>📚 Bibliotecă Resurse</div>
              <button onClick={()=>open("addRes")} className="btn gold sm">+ Resursă</button>
            </div>
            {[...Array(12)].map((_,i)=>{
              const nr=i+1;
              const res=resources.filter(r=>r.lessonNumber===nr);
              return(
                <div key={nr} className="card" style={{marginBottom:8}}>
                  <div style={{fontSize:11,color:GOLD,letterSpacing:2,marginBottom:res.length?10:0}}>ȘEDINȚA {nr}</div>
                  {res.map(r=>(
                    <div key={r.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 0",borderTop:"1px solid rgba(255,255,255,0.06)"}}>
                      <div style={{fontSize:18}}>{r.type==="pdf"?"📄":r.type==="video"?"🎬":r.type==="link"?"🔗":"📎"}</div>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:13,fontWeight:600,color:"#eee"}}>{r.title}</div>
                        {r.description&&<div style={{fontSize:11,color:"#555",marginTop:2}}>{r.description}</div>}
                        {r.url&&<a href={r.url} target="_blank" rel="noreferrer" style={{fontSize:11,color:"#3498DB",display:"block",marginTop:3}}>Deschide →</a>}
                      </div>
                      <button onClick={async()=>{if(window.confirm("Stergi?"))await deleteDoc(doc(db,"school_resources",r.id));}} className="btn gh-r sm" style={{flexShrink:0}}>🗑</button>
                    </div>
                  ))}
                  {res.length===0&&<div style={{fontSize:11,color:"#333",fontStyle:"italic"}}>Nicio resursă adăugată</div>}
                </div>
              );
            })}
          </>
        )}

      </div>

      <BottomNav items={navItems} active={view} onChange={setView} onLogout={onLogout}/>

      {/* ── MODALS ── */}

      <Modal open={!!M.addS} onClose={()=>close("addS")}>
        <div className="serif" style={{fontSize:20,color:GOLD,marginBottom:16}}>+ Cursant nou</div>
        <F label="Nume complet *" value={sF.name} onChange={e=>setSF({...sF,name:e.target.value})} placeholder="Ion Popescu"/>
        <F label="Email *" type="email" value={sF.email} onChange={e=>setSF({...sF,email:e.target.value})}/>
        <F label="Telefon" value={sF.phone} onChange={e=>setSF({...sF,phone:e.target.value})} placeholder="+40..."/>
        <F label="Mentor"><select className="fi" value={sF.mentorId} onChange={e=>setSF({...sF,mentorId:e.target.value})}><option value="">Fără mentor</option>{mentors.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}</select></F>
        <F label="Pachet / Curs" value={sF.package} onChange={e=>setSF({...sF,package:e.target.value})} placeholder="Standard / Plus / Premium"/>
        <F label="Data start" type="date" value={sF.startDate} onChange={e=>setSF({...sF,startDate:e.target.value})}/>
        <F label="Note" multiline value={sF.notes} onChange={e=>setSF({...sF,notes:e.target.value})} rows={3}/>
        <button onClick={mkStudent} disabled={saving} className="btn gold full">{saving?"Se creează...":"Creează cont cursant"}</button>
      </Modal>

      <Modal open={!!M.addM} onClose={()=>close("addM")}>
        <div className="serif" style={{fontSize:20,color:"#3498DB",marginBottom:16}}>+ Mentor nou</div>
        <F label="Nume complet *" value={mF.name} onChange={e=>setMF({...mF,name:e.target.value})}/>
        <F label="Email *" type="email" value={mF.email} onChange={e=>setMF({...mF,email:e.target.value})}/>
        <F label="Telefon" value={mF.phone} onChange={e=>setMF({...mF,phone:e.target.value})}/>
        <F label="Bio" multiline value={mF.bio} onChange={e=>setMF({...mF,bio:e.target.value})} rows={3}/>
        <button onClick={mkMentor} disabled={saving} className="btn blue full">{saving?"Se creează...":"Creează cont mentor"}</button>
      </Modal>

      <Modal open={!!M.addMod} onClose={()=>close("addMod")}>
        <div className="serif" style={{fontSize:20,color:GOLD,marginBottom:16}}>+ Modul nou</div>
        <F label="Titlu (RO) *" value={modF.title} onChange={e=>setModF({...modF,title:e.target.value})}/>
        <F label="Titlu (EN)" value={modF.titleEn} onChange={e=>setModF({...modF,titleEn:e.target.value})}/>
        <F label="Descriere" multiline value={modF.description} onChange={e=>setModF({...modF,description:e.target.value})} rows={3}/>
        <button onClick={async()=>{if(!modF.title)return;await addDoc(collection(db,"school_curriculum"),{...modF,type:"module",order:curriculum.length,lessons:[],createdAt:serverTimestamp()});setModF({title:"",titleEn:"",description:""});close("addMod");toast("Modul adăugat!","success");}} className="btn gold full">Adaugă modul</button>
      </Modal>

      <Modal open={!!lesFor} onClose={()=>setLesFor(null)}>
        <div className="serif" style={{fontSize:20,color:GOLD,marginBottom:16}}>+ Lecție nouă</div>
        <F label="Titlu (RO) *" value={lesF.title} onChange={e=>setLesF({...lesF,title:e.target.value})}/>
        <F label="Titlu (EN)" value={lesF.titleEn} onChange={e=>setLesF({...lesF,titleEn:e.target.value})}/>
        <F label="Descriere" multiline value={lesF.description} onChange={e=>setLesF({...lesF,description:e.target.value})} rows={3}/>
        <F label="Durată (minute)" type="number" value={lesF.duration} onChange={e=>setLesF({...lesF,duration:parseInt(e.target.value)||60})}/>
        <button onClick={async()=>{if(!lesF.title)return;const snap=await getDoc(doc(db,"school_curriculum",lesFor));const lessons=snap.data().lessons||[];await updateDoc(doc(db,"school_curriculum",lesFor),{lessons:[...lessons,{id:Date.now().toString(),...lesF}]});setLesF({title:"",titleEn:"",description:"",duration:60});setLesFor(null);toast("Lecție adăugată!","success");}} className="btn gold full">Adaugă lecție</button>
      </Modal>

      <Modal open={!!editMod} onClose={()=>setEditMod(null)}>
        <div className="serif" style={{fontSize:20,color:GOLD,marginBottom:16}}>✏️ Editează Modulul</div>
        <F label="Titlu (RO) *" value={editModF.title} onChange={e=>setEditModF(f=>({...f,title:e.target.value}))}/>
        <F label="Titlu (EN)" value={editModF.titleEn} onChange={e=>setEditModF(f=>({...f,titleEn:e.target.value}))}/>
        <F label="Descriere" multiline value={editModF.description} onChange={e=>setEditModF(f=>({...f,description:e.target.value}))} rows={3}/>
        <button onClick={async()=>{if(!editMod||!editModF.title)return;await updateMod(editMod.id,editModF);setEditMod(null);}} disabled={saving} className="btn gold full">💾 Salvează modulul</button>
      </Modal>

      <Modal open={!!editLes} onClose={()=>setEditLes(null)}>
        <div className="serif" style={{fontSize:20,color:GOLD,marginBottom:16}}>✏️ Editează Lecția</div>
        <F label="Titlu (RO) *" value={editLesF.title} onChange={e=>setEditLesF(f=>({...f,title:e.target.value}))}/>
        <F label="Titlu (EN)" value={editLesF.titleEn} onChange={e=>setEditLesF(f=>({...f,titleEn:e.target.value}))}/>
        <F label="Descriere" multiline value={editLesF.description} onChange={e=>setEditLesF(f=>({...f,description:e.target.value}))} rows={3}/>
        <F label="Durată (minute)" type="number" value={editLesF.duration} onChange={e=>setEditLesF(f=>({...f,duration:e.target.value}))}/>
        <button onClick={async()=>{if(!editLes||!editLesF.title)return;await updateLes(editLes.modId,editLes.lesIdx,editLesF);setEditLes(null);}} disabled={saving} className="btn gold full">💾 Salvează lecția</button>
      </Modal>

      {/* CONFIRMARE RESET */}
      <Modal open={!!resetConfirm} onClose={()=>setResetConfirm(null)}>
        {resetConfirm&&(
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:40,marginBottom:12}}>🔄</div>
            <div className="serif" style={{fontSize:20,color:"#F39C12",marginBottom:8}}>Resetezi cursantul?</div>
            <div style={{fontSize:14,color:"#eee",marginBottom:6}}>{resetConfirm.name}</div>
            <div style={{background:"rgba(243,156,18,0.08)",border:"1px solid rgba(243,156,18,0.2)",borderRadius:10,padding:"12px 14px",marginBottom:20,textAlign:"left"}}>
              <div style={{fontSize:12,color:"#F39C12",fontWeight:600,marginBottom:6}}>Se șterge:</div>
              <div style={{fontSize:12,color:"#aaa",lineHeight:1.8}}>✕ Toate ședințele<br/>✕ Progresul lecțiilor<br/>✕ Video-urile uploadate<br/>✕ Contorul de ședințe</div>
              <div style={{fontSize:12,color:"#2ECC71",fontWeight:600,marginTop:8,marginBottom:4}}>Se păstrează:</div>
              <div style={{fontSize:12,color:"#aaa",lineHeight:1.8}}>✓ Contul (email + parolă)<br/>✓ Datele personale<br/>✓ Mentorul asignat</div>
            </div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>setResetConfirm(null)} className="btn gh full">Anulează</button>
              <button onClick={resetStudent} disabled={saving} className="btn full" style={{background:"linear-gradient(135deg,#F39C12,#E67E22)",color:"#fff"}}>{saving?"Se resetează...":"🔄 Resetează"}</button>
            </div>
          </div>
        )}
      </Modal>

      <Modal open={!!M.addSe} onClose={()=>close("addSe")}>
        <div className="serif" style={{fontSize:20,color:"#2ECC71",marginBottom:16}}>+ Ședință nouă</div>
        <F label="Cursant *"><select className="fi" value={seF.studentId} onChange={e=>setSeF({...seF,studentId:e.target.value})}><option value="">Selectează cursant</option>{students.map(s=><option key={s.id} value={s.id}>{s.name}</option>)}</select></F>
        <F label="Mentor"><select className="fi" value={seF.mentorId} onChange={e=>setSeF({...seF,mentorId:e.target.value})}><option value="">Fără mentor</option>{mentors.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}</select></F>
        <div className="two-col">
          <F label="Dată *" type="date" value={seF.date} onChange={e=>setSeF({...seF,date:e.target.value})}/>
          <F label="Oră" type="time" value={seF.time} onChange={e=>setSeF({...seF,time:e.target.value})}/>
        </div>
        <F label="Locație" value={seF.location} onChange={e=>setSeF({...seF,location:e.target.value})}/>
        <F label="Link Video" value={seF.videoUrl} onChange={e=>setSeF({...seF,videoUrl:e.target.value})} placeholder="https://..."/>
        <F label="Note" multiline value={seF.notes} onChange={e=>setSeF({...seF,notes:e.target.value})} rows={2}/>
        <button onClick={mkSession} disabled={saving} className="btn grn full">{saving?"Se salvează...":"Programează ședință"}</button>
      </Modal>

      <Modal open={!!detail} onClose={()=>setDetail(null)}>
        {detail&&<StudentDetail student={detail} sessions={sessions} curriculum={curriculum} mentors={mentors} toast={toast}/>}
      </Modal>

      <Modal open={!!qrMod} onClose={()=>setQrMod(null)}>
        {qrMod&&(
          <div style={{textAlign:"center"}}>
            <div className="serif" style={{fontSize:20,color:GOLD,marginBottom:6}}>{qrMod.student.name}</div>
            <div style={{fontSize:12,color:"#555",marginBottom:18}}>QR pentru prezență</div>
            <img src={qrMod.qr} alt="QR" style={{width:"100%",maxWidth:240,height:"auto",borderRadius:12}}/>
            <a href={qrMod.qr} download={`qr-${qrMod.student.name}.png`} className="btn gold full" style={{display:"flex",marginTop:18}}>⬇ Descarcă QR</a>
          </div>
        )}
      </Modal>

      {/* CREDENTIALE */}
      <Modal open={!!cred} onClose={()=>setCred(null)}>
        {cred&&(
          <div>
            <div style={{textAlign:"center",marginBottom:18}}>
              <div style={{fontSize:36,marginBottom:8}}>🔐</div>
              <div className="serif" style={{fontSize:20,color:GOLD}}>Cont creat!</div>
              <div style={{fontSize:12,color:"#555",marginTop:4}}>Salvează parola — nu va mai fi afișată.</div>
            </div>
            <div style={{background:"rgba(255,255,255,0.03)",border:`1px solid rgba(212,175,55,0.2)`,borderRadius:12,padding:16,marginBottom:14}}>
              <div style={{marginBottom:12}}><div style={{fontSize:10,color:"#555",letterSpacing:1,marginBottom:3}}>NUME</div><div style={{fontSize:15,color:"#eee",fontWeight:600}}>{cred.name}</div></div>
              <div style={{marginBottom:12}}><div style={{fontSize:10,color:"#555",letterSpacing:1,marginBottom:3}}>EMAIL</div><div style={{fontSize:13,color:"#eee",fontFamily:"monospace",background:"rgba(255,255,255,0.05)",padding:"8px 10px",borderRadius:8,wordBreak:"break-all"}}>{cred.email}</div></div>
              <div><div style={{fontSize:10,color:"#555",letterSpacing:1,marginBottom:3}}>PAROLĂ TEMPORARĂ</div><div style={{fontSize:22,color:GOLD,fontFamily:"monospace",fontWeight:700,background:"rgba(212,175,55,0.08)",padding:"10px 14px",borderRadius:8,letterSpacing:3}}>{cred.password}</div></div>
            </div>
            <button onClick={()=>{navigator.clipboard.writeText(`Email: ${cred.email}\nParolă: ${cred.password}`);toast("Copiat!","success");}} className="btn gh-g full" style={{marginBottom:10}}>📋 Copiază credențialele</button>
            <button onClick={()=>setCred(null)} className="btn gold full">Am salvat parola ✓</button>
          </div>
        )}
      </Modal>

      {/* CONFIRMARE STERGERE */}
      <Modal open={!!delConfirm} onClose={()=>setDelConfirm(null)}>
        {delConfirm&&(
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:40,marginBottom:12}}>⚠️</div>
            <div className="serif" style={{fontSize:20,color:"#E74C3C",marginBottom:8}}>Ștergi contul?</div>
            <div style={{fontSize:14,color:"#eee",marginBottom:6}}>{delConfirm.name}</div>
            <div style={{fontSize:12,color:"#555",marginBottom:20}}>Tip: {delConfirm.role}. Această acțiune este ireversibilă. Toate ședințele asociate vor fi șterse.</div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>setDelConfirm(null)} className="btn gh full">Anulează</button>
              <button onClick={deleteAccount} disabled={saving} className="btn red full">{saving?"Se șterge...":"Șterge definitiv"}</button>
            </div>
          </div>
        )}
      </Modal>

      {/* MODAL JURNAL */}
      <Modal open={!!M.jurnal} onClose={()=>close("jurnal")}>
        <div className="serif" style={{fontSize:20,color:GOLD,marginBottom:16}}>📓 Jurnal Ședință</div>
        {jurnalSes&&(
          <div style={{fontSize:12,color:"#555",marginBottom:14}}>
            {students.find(x=>x.id===jurnalSes.studentId)?.name||"Cursant"} · {jurnalSes.date} · {jurnalSes.time}
          </div>
        )}
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <div>
            <div style={{fontSize:11,color:"#2ECC71",letterSpacing:1,marginBottom:6}}>FEEDBACK MENTOR (vizibil cursantului)</div>
            <textarea value={jurnalF.mentorFeedback} onChange={e=>setJurnalF(f=>({...f,mentorFeedback:e.target.value}))}
              placeholder="Ce a mers bine, ce trebuie îmbunătățit, progres observat..."
              rows={4} style={{width:"100%",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(46,204,113,0.25)",borderRadius:10,padding:"10px 14px",color:"#eee",fontSize:13,resize:"vertical",outline:"none"}}/>
          </div>
          <div>
            <div style={{fontSize:11,color:GOLD,letterSpacing:1,marginBottom:6}}>TASKURI ACASĂ (vizibil cursantului)</div>
            <textarea value={jurnalF.tasksCasa} onChange={e=>setJurnalF(f=>({...f,tasksCasa:e.target.value}))}
              placeholder="Ex: Exersează beatmatching 15min/zi, pregătește playlist de 20 piese..."
              rows={3} style={{width:"100%",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(212,175,55,0.25)",borderRadius:10,padding:"10px 14px",color:"#eee",fontSize:13,resize:"vertical",outline:"none"}}/>
          </div>
          <div>
            <div style={{fontSize:11,color:"#3498DB",letterSpacing:1,marginBottom:6}}>NOTE INTERNE (doar admin)</div>
            <textarea value={jurnalF.observatii} onChange={e=>setJurnalF(f=>({...f,observatii:e.target.value}))}
              placeholder="Observații interne, nu sunt vizibile cursantului..."
              rows={2} style={{width:"100%",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(52,152,219,0.2)",borderRadius:10,padding:"10px 14px",color:"#eee",fontSize:13,resize:"vertical",outline:"none"}}/>
          </div>
          <button onClick={saveJurnal} disabled={jurnalSaving} className="btn gold full">
            {jurnalSaving?"Se salvează...":"💾 Salvează jurnalul"}
          </button>
        </div>
      </Modal>

      {/* MODAL ADAUGA RESURSA */}
      <Modal open={!!M.addRes} onClose={()=>close("addRes")}>
        <div className="serif" style={{fontSize:20,color:GOLD,marginBottom:16}}>📚 Resursă nouă</div>
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          <input value={resF.title} onChange={e=>setResF(f=>({...f,title:e.target.value}))}
            placeholder="Titlu resursă *" className="inp"/>
          <input value={resF.description} onChange={e=>setResF(f=>({...f,description:e.target.value}))}
            placeholder="Descriere scurtă" className="inp"/>
          <div style={{display:"flex",gap:8}}>
            <select value={resF.lessonNumber} onChange={e=>setResF(f=>({...f,lessonNumber:e.target.value}))}
              style={{flex:1,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,padding:"10px 14px",color:"#eee",fontSize:14,outline:"none"}}>
              <option value="">Ședința (toate)</option>
              {[...Array(12)].map((_,i)=><option key={i+1} value={i+1}>Ședința {i+1}</option>)}
            </select>
            <select value={resF.type} onChange={e=>setResF(f=>({...f,type:e.target.value}))}
              style={{flex:1,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,padding:"10px 14px",color:"#eee",fontSize:14,outline:"none"}}>
              <option value="pdf">📄 PDF</option>
              <option value="video">🎬 Video</option>
              <option value="link">🔗 Link</option>
              <option value="text">📝 Text/Exercițiu</option>
            </select>
          </div>
          <input value={resF.url} onChange={e=>setResF(f=>({...f,url:e.target.value}))}
            placeholder="URL (dacă există link extern)" className="inp"/>
          <div style={{fontSize:11,color:"#555",textAlign:"center"}}>— sau —</div>
          <div>
            <div style={{fontSize:11,color:"#888",marginBottom:6}}>Upload fișier PDF</div>
            <input type="file" accept=".pdf,.zip" onChange={e=>setResFile(e.target.files[0]||null)}
              style={{fontSize:12,color:"#888",width:"100%"}}/>
            {resFile&&<div style={{fontSize:11,color:"#2ECC71",marginTop:4}}>✓ {resFile.name}</div>}
          </div>
          <button onClick={saveResource} disabled={resUploading} className="btn gold full">
            {resUploading?"Se încarcă...":"💾 Salvează resursa"}
          </button>
        </div>
      </Modal>
    </div>
  );
}

// ════════════════════════════════════════════════
// MENTOR DASHBOARD
// ════════════════════════════════════════════════
function MentorDashboard({ user, onLogout, toast }) {
  const [view,setView]=useState("students");
  const [students,setStudents]=useState([]);
  const [sessions,setSessions]=useState([]);
  const [curriculum,setCurriculum]=useState([]);
  const [videos,setVideos]=useState([]); // video-uri uploadate de cursanți
  const [chatSt,setChatSt]=useState(null);
  const [chatMsgs,setChatMsgs]=useState([]);
  const [chatMsg,setChatMsg]=useState("");
  const [expandId,setExpandId]=useState(null);
  const [revMod,setRevMod]=useState(null);
  const [revText,setRevText]=useState("");
  const chatEnd=useRef(null);
  const [sesEditMod,setSesEditMod]=useState(null); // sedinta de editat
  const [sesEditF,setSesEditF]=useState({date:"",time:"",location:"",notes:"",videoUrl:""});
  const [sesEditSaving,setSesEditSaving]=useState(false);
  const [mentorQR,setMentorQR]=useState(false); // modal QR scanner
  const [sesFilter,setSesFilter]=useState("all");
  const [obStudent,setObStudent]=useState(null);
  const [obStudentData,setObStudentData]=useState([]);
  const [obF,setObF]=useState({text:"",deadline:"",notes:""});
  const [obSaving,setObSaving]=useState(false);
  const [plStudent,setPlStudent]=useState(null);
  const [plData,setPlData]=useState([]);
  const [mixStudent,setMixStudent]=useState(null);
  const [mixStudentData,setMixStudentData]=useState([]);

  // Programari din booking app
  const bookingAppointments=useBookingAppointments(user.email,"mentor");

  useEffect(()=>{
    const u1=onSnapshot(query(collection(db,"school_users"),where("role","==","student"),where("mentorId","==",user.uid)),s=>setStudents(s.docs.map(d=>({id:d.id,...d.data()}))));
    const u2=onSnapshot(query(collection(db,"school_sessions"),where("mentorId","==",user.uid)),s=>setSessions(s.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>(b.date||"").localeCompare(a.date||""))));
    const u3=onSnapshot(query(collection(db,"school_curriculum"),orderBy("order","asc")),s=>setCurriculum(s.docs.map(d=>({id:d.id,...d.data()}))));
    const u4=onSnapshot(query(collection(db,"school_student_videos"),where("mentorId","==",user.uid)),s=>setVideos(s.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>(b.createdAt?.seconds||0)-(a.createdAt?.seconds||0))));
    return()=>{u1();u2();u3();u4();};
  },[user.uid]);

  useEffect(()=>{
    if(!obStudent)return;
    return onSnapshot(query(collection(db,"school_obiective"),where("studentId","==",obStudent.id)),s=>
      setObStudentData(s.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>(a.createdAt?.seconds||0)-(b.createdAt?.seconds||0))));
  },[obStudent]);

  useEffect(()=>{
    if(!plStudent)return;
    return onSnapshot(query(collection(db,"school_playlist"),where("studentId","==",plStudent.id)),s=>
      setPlData(s.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>(b.createdAt?.seconds||0)-(a.createdAt?.seconds||0))));
  },[plStudent]);

  useEffect(()=>{
    if(!mixStudent)return;
    return onSnapshot(query(collection(db,"school_mixes"),where("studentId","==",mixStudent.id)),s=>
      setMixStudentData(s.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>(b.createdAt?.seconds||0)-(a.createdAt?.seconds||0))));
  },[mixStudent]);

  const addObiectiv=async()=>{
    if(!obF.text||!obStudent){toast("Textul obiectivului e obligatoriu.","error");return;}
    setObSaving(true);
    await addDoc(collection(db,"school_obiective"),{...obF,studentId:obStudent.id,studentName:obStudent.name,mentorId:user.uid,done:false,createdAt:serverTimestamp()});
    setObF({text:"",deadline:"",notes:""});
    toast("Obiectiv adăugat!","success");
    setObSaving(false);
  };
  const deleteObiectiv=async(id)=>await deleteDoc(doc(db,"school_obiective",id));

  // ── MANAGEMENT ȘEDINȚE ──
  const markSessionDone=async(ses)=>{
    await updateDoc(doc(db,"school_sessions",ses.id),{status:"completed",completedAt:serverTimestamp()});
    const snap=await getDoc(doc(db,"school_users",ses.studentId));
    await updateDoc(doc(db,"school_users",ses.studentId),{sessionsCount:(snap.data()?.sessionsCount||0)+1});
    toast("Ședință marcată efectuată!","success");
  };
  const cancelSession=async(sesId)=>{
    await updateDoc(doc(db,"school_sessions",sesId),{status:"cancelled",cancelledAt:serverTimestamp()});
    toast("Ședință anulată.","info");
  };
  const rescheduleSession=async(sesId)=>{
    await updateDoc(doc(db,"school_sessions",sesId),{status:"scheduled",completedAt:null});
    toast("Ședință reprogramată.","info");
  };
  const saveSesEdit=async()=>{
    if(!sesEditMod)return;
    setSesEditSaving(true);
    try{
      await updateDoc(doc(db,"school_sessions",sesEditMod.id),{
        date:sesEditF.date,time:sesEditF.time,
        location:sesEditF.location,notes:sesEditF.notes,
        videoUrl:sesEditF.videoUrl,
      });
      toast("Ședință actualizată!","success");
      setSesEditMod(null);
    }catch(e){toast("Eroare: "+e.message,"error");}
    setSesEditSaving(false);
  };

  useEffect(()=>{
    if(!chatSt)return;
    const chatId=[user.uid,chatSt.id].sort().join("_");
    return onSnapshot(query(collection(db,"school_chats",chatId,"messages"),orderBy("createdAt","asc")),s=>{
      setChatMsgs(s.docs.map(d=>({id:d.id,...d.data()})));
      setTimeout(()=>chatEnd.current?.scrollIntoView({behavior:"smooth"}),100);
    });
  },[chatSt,user.uid]);

  const sendMsg=async()=>{
    if(!chatMsg.trim()||!chatSt)return;
    const chatId=[user.uid,chatSt.id].sort().join("_");
    await addDoc(collection(db,"school_chats",chatId,"messages"),{text:chatMsg.trim(),senderId:user.uid,senderName:user.name,createdAt:serverTimestamp()});
    setChatMsg("");
  };

  const toggleLesson=async(sid,lid,completed)=>{
    const upd=completed.includes(lid)?completed.filter(l=>l!==lid):[...completed,lid];
    await updateDoc(doc(db,"school_users",sid),{completedLessons:upd});
    toast("Progres actualizat!","success");
  };

  const addReview=async(videoId)=>{
    if(!revText.trim())return;
    await updateDoc(doc(db,"school_student_videos",videoId),{mentorReview:revText.trim(),reviewedAt:serverTimestamp()});
    // Notificam cursantul in chat
    const video=videos.find(v=>v.id===videoId);
    if(video&&chatSt?.id===video.studentId){
      const chatId=[user.uid,video.studentId].sort().join("_");
      await addDoc(collection(db,"school_chats",chatId,"messages"),{
        text:`📝 Am lăsat un review pentru video-ul tău: "${revText.trim()}"`,
        senderId:user.uid,senderName:user.name,createdAt:serverTimestamp()
      });
    }
    toast("Review salvat!","success");
    setRevMod(null);setRevText("");
  };

  const navItems=[
    {id:"students",  icon:"✦", label:"Cursanți"},
    {id:"sessions",  icon:"📅",label:"Ședințe"},
    {id:"scan",      icon:"⬡", label:"Scan QR"},
    {id:"jurnal",    icon:"📓",label:"Jurnal"},
    {id:"videos",    icon:"🎬",label:"Video-uri"},
    {id:"obiective", icon:"🎯",label:"Obiective"},
    {id:"playlist",  icon:"🎵",label:"Playlist"},
    {id:"mixes",     icon:"🎚️",label:"Mix-uri"},
    {id:"resurse",   icon:"📚",label:"Resurse"},
    {id:"chat",      icon:"💬",label:"Chat"},
  ];

  // State jurnal mentor
  const [jurnalSes,setJurnalSes]=useState(null);
  const [jurnalF,setJurnalF]=useState({mentorFeedback:"",tasksCasa:"",observatii:""});
  const [jurnalSaving,setJurnalSaving]=useState(false);

  const saveJurnal=async()=>{
    if(!jurnalSes)return;
    setJurnalSaving(true);
    try{
      await updateDoc(doc(db,"school_sessions",jurnalSes.id),{
        mentorFeedback:jurnalF.mentorFeedback,
        tasksCasa:jurnalF.tasksCasa,
        jurnalUpdatedAt:serverTimestamp(),
      });
      toast("Jurnal salvat!","success");
      setJurnalSes(null);
    }catch(e){toast("Eroare: "+e.message,"error");}
    setJurnalSaving(false);
  };

  // Toate sesiunile: din school_sessions + din booking app
  const allSessions=[
    ...sessions,
    ...bookingAppointments.map(a=>({
      id:"booking_"+a.id,
      studentId:a.studentUid,
      date:a.date,
      time:a.time,
      location:a.location||"Booking App",
      status:a.status==="confirmed"?"scheduled":"scheduled",
      source:"booking",
      notes:a.notes||""
    }))
  ];

  return (
    <div className="shell" style={{background:DARK}}>
      <style>{CSS}</style>
      <TopBar
        left={<div><div className="serif" style={{fontSize:17,fontWeight:600,color:"#3498DB"}}>DJ School</div><div style={{fontSize:9,color:"#333",letterSpacing:2}}>MENTOR</div></div>}
        center={<div style={{fontSize:11,color:"#555"}} className="trunc">{user.name}</div>}
        right={<button onClick={onLogout} className="btn gh sm">⎋</button>}
      />
      <Sidebar items={navItems} active={view} onChange={setView} onLogout={onLogout} user={user} accent="sb">
        <div style={{fontSize:11,color:"#444",marginTop:8}}>{user.name}</div>
      </Sidebar>

      <div className="scroll fu">

        {/* CURSANȚI */}
        {view==="students"&&(
          <>
            <div className="serif" style={{fontSize:22,color:"#3498DB",marginBottom:14}}>✦ Cursanții mei</div>
            {students.map(s=>{
              const allL=curriculum.reduce((a,m)=>a+(m.lessons||[]).length,0);
              const done=(s.completedLessons||[]).length;
              const prog=allL>0?Math.round(done/allL*100):0;
              const exp=expandId===s.id;
              return (
                <div key={s.id} className="card">
                  <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
                    <div style={{width:42,height:42,borderRadius:12,background:"rgba(52,152,219,0.12)",border:"1px solid rgba(52,152,219,0.2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}} className="serif">{s.name?.charAt(0)}</div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:14,fontWeight:600,color:"#eee"}}>{s.name}</div>
                      <div style={{fontSize:11,color:"#555"}}>{s.package||"Curs DJ"} · {s.sessionsCount||0} ședințe</div>
                    </div>
                    <div style={{display:"flex",gap:6,flexShrink:0}}>
                      <button onClick={()=>{setChatSt(s);setView("chat");}} className="btn gh-b sm">💬</button>
                      <button onClick={()=>setExpandId(exp?null:s.id)} className="btn gh-g sm">{exp?"▲":"▼"}</button>
                    </div>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <div className="pt" style={{flex:1}}><div className="pf" style={{width:`${prog}%`,background:"linear-gradient(90deg,#3498DB,#5DADE2)"}}/></div>
                    <div style={{fontSize:12,color:"#3498DB",fontWeight:600,width:36,flexShrink:0}}>{prog}%</div>
                  </div>
                  {exp&&(
                    <div style={{marginTop:14,borderTop:`1px solid ${BORDER}`,paddingTop:14}}>
                      {curriculum.map((mod,idx)=>(
                        <div key={mod.id} style={{marginBottom:12}}>
                          <div style={{fontSize:10,color:GOLD,letterSpacing:2,marginBottom:6}}>MODUL {idx+1} · {mod.title}</div>
                          {(mod.lessons||[]).map(l=>{
                            const isDone=(s.completedLessons||[]).includes(l.id);
                            return (
                              <div key={l.id} onClick={()=>toggleLesson(s.id,l.id,s.completedLessons||[])} style={{display:"flex",alignItems:"center",gap:8,padding:"9px 8px",borderRadius:8,cursor:"pointer",marginBottom:4,background:isDone?"rgba(46,204,113,0.05)":"transparent",minHeight:40}}>
                                <div style={{width:20,height:20,borderRadius:5,background:isDone?"#2ECC71":"rgba(255,255,255,0.05)",border:`1px solid ${isDone?"#2ECC71":BORDER}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,color:isDone?"#fff":"#333",flexShrink:0}}>{isDone?"✓":""}</div>
                                <div style={{fontSize:12,color:isDone?"#2ECC71":"#aaa"}}>{l.title}</div>
                              </div>
                            );
                          })}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
            {students.length===0&&<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Niciun cursant asignat.</div>}
          </>
        )}

        {/* ȘEDINȚE */}
        {view==="sessions"&&(
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:8}}>
              <div className="serif" style={{fontSize:22,color:"#2ECC71"}}>📅 Ședințele mele</div>
              <button onClick={()=>setView("scan")} className="btn gold sm">⬡ Scan QR Check-in</button>
            </div>
            {/* Filtre status */}
            <div style={{display:"flex",gap:6,marginBottom:14,flexWrap:"wrap"}}>
              {[["all","Toate"],["scheduled","Programate"],["completed","Efectuate"],["cancelled","Anulate"]].map(([v,l])=>(
                <button key={v} onClick={()=>setSesFilter(v)} style={{padding:"6px 12px",borderRadius:8,background:sesFilter===v?"rgba(46,204,113,0.15)":"rgba(255,255,255,0.03)",border:`1px solid ${sesFilter===v?"rgba(46,204,113,0.4)":BORDER}`,color:sesFilter===v?"#2ECC71":"#555",fontSize:12,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>{l}</button>
              ))}
            </div>
            {(()=>{
              const filtered=allSessions.filter(s=>sesFilter==="all"||s.status===sesFilter);
              return(<>
                {bookingAppointments.length>0&&sesFilter==="all"&&(
                  <div style={{background:"rgba(212,175,55,0.05)",border:`1px solid rgba(212,175,55,0.2)`,borderRadius:12,padding:"10px 14px",marginBottom:14}}>
                    <div style={{fontSize:10,color:GOLD,letterSpacing:2,marginBottom:6}}>📌 DIN BOOKING APP</div>
                    {bookingAppointments.slice(0,5).map(a=>(
                      <div key={a.id} style={{fontSize:13,color:"#eee",marginBottom:4}}>
                        {a.date} {a.time} · {a.clientName||a.studentName||"—"}
                        <span style={{fontSize:10,color:GOLD,marginLeft:8}}>✓ Confirmat</span>
                      </div>
                    ))}
                  </div>
                )}
                {filtered.map(s=>{
                  const st=students.find(x=>x.id===s.studentId);
                  const statusColor=s.status==="completed"?"#2ECC71":s.status==="cancelled"?"#E74C3C":GOLD;
                  const statusLabel=s.status==="completed"?"Efectuată":s.status==="cancelled"?"Anulată":"Programată";
                  return(
                    <div key={s.id} className="card" style={{borderColor:s.status==="cancelled"?"rgba(231,76,60,0.2)":s.status==="completed"?"rgba(46,204,113,0.15)":BORDER}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,marginBottom:10}}>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontSize:14,fontWeight:600,color:"#eee"}}>{st?.name||s.clientName||"—"}</div>
                          <div style={{fontSize:11,color:"#666",marginTop:2}}>{s.date} · {s.time} · {s.location}</div>
                          {s.checkinAt&&<div style={{fontSize:10,color:"#2ECC71",marginTop:2}}>✓ Check-in înregistrat</div>}
                          {s.source==="booking"&&<div style={{fontSize:10,color:GOLD,marginTop:2}}>📌 Booking App</div>}
                        </div>
                        <Badge label={statusLabel} color={statusColor}/>
                      </div>
                      {s.videoUrl&&(
                        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8,flexWrap:"wrap"}}>
                          <a href={s.videoUrl} target="_blank" rel="noreferrer" style={{fontSize:12,color:"#3498DB"}}>🎬 Video</a>
                          {!s.mentorReview&&s.status==="completed"&&<button onClick={()=>{setRevMod({type:"session",id:s.id});setRevText("");}} className="btn gh-g sm">+ Review</button>}
                          {s.mentorReview&&<span style={{fontSize:11,color:"#2ECC71"}}>✓ Review adăugat</span>}
                        </div>
                      )}
                      {!s.source&&(
                        <div style={{display:"flex",gap:6,flexWrap:"wrap",borderTop:`1px solid ${BORDER}`,paddingTop:10}}>
                          {s.status==="scheduled"&&(
                            <>
                              <button onClick={()=>markSessionDone(s)} className="btn grn sm">✓ Marchează efectuată</button>
                              <button onClick={()=>cancelSession(s.id)} className="btn gh-r sm">✕ Anulează</button>
                            </>
                          )}
                          {s.status==="completed"&&(
                            <>
                              <button onClick={()=>{setJurnalSes(s);setJurnalF({mentorFeedback:s.mentorFeedback||"",tasksCasa:s.tasksCasa||"",observatii:""});setView("jurnal");}} className="btn gh sm" style={{fontSize:11}}>
                                {s.mentorFeedback?"📓 Edit jurnal":"📓 Adaugă jurnal"}
                              </button>
                              <button onClick={()=>rescheduleSession(s.id)} className="btn gh sm" style={{fontSize:11,color:GOLD,borderColor:"rgba(212,175,55,0.3)"}}>↩ Reprogramează</button>
                            </>
                          )}
                          {s.status==="cancelled"&&(
                            <button onClick={()=>rescheduleSession(s.id)} className="btn gh sm" style={{fontSize:11,color:GOLD,borderColor:"rgba(212,175,55,0.3)"}}>↩ Reactivează</button>
                          )}
                          <button onClick={()=>{setSesEditMod(s);setSesEditF({date:s.date||"",time:s.time||"",location:s.location||"",notes:s.notes||"",videoUrl:s.videoUrl||""});}} className="btn gh sm" style={{fontSize:11}}>✏️ Editează</button>
                          <button onClick={()=>{if(window.confirm("Ștergi definitiv această ședință?"))deleteDoc(doc(db,"school_sessions",s.id));}} className="btn gh-r sm" style={{fontSize:11}}>🗑</button>
                        </div>
                      )}
                    </div>
                  );
                })}
                {filtered.length===0&&<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Nicio ședință{sesFilter!=="all"?` cu status "${sesFilter}"`:""}.</div>}
              </>);
            })()}
          </>
        )}

        {/* SCAN QR MENTOR */}
        {view==="scan"&&(
          <>
            <div className="serif" style={{fontSize:22,color:GOLD,marginBottom:14}}>⬡ Check-in QR</div>
            <QRScanner students={students} sessions={sessions} toast={toast}/>
          </>
        )}

        {/* JURNAL MENTOR */}
        {view==="jurnal"&&(
          <>
            <div className="serif" style={{fontSize:22,color:GOLD,marginBottom:16}}>📓 Jurnal Ședințe</div>
            {allSessions.filter(s=>s.status==="completed"&&!s.source).map(s=>{
              const st=students.find(x=>x.id===s.studentId);
              const hasJurnal=s.mentorFeedback||s.tasksCasa;
              return(
                <div key={s.id} className="card" style={{borderColor:hasJurnal?"rgba(46,204,113,0.25)":BORDER}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:13,fontWeight:600,color:"#eee"}}>{st?.name||"Cursant"}</div>
                      <div style={{fontSize:11,color:"#555",marginTop:2}}>{s.date} · {s.time}</div>
                      {hasJurnal&&(
                        <div style={{marginTop:10,display:"flex",flexDirection:"column",gap:7}}>
                          {s.mentorFeedback&&(
                            <div style={{background:"rgba(46,204,113,0.05)",border:"1px solid rgba(46,204,113,0.15)",borderRadius:8,padding:"8px 12px"}}>
                              <div style={{fontSize:9,color:"#2ECC71",letterSpacing:2,marginBottom:4}}>FEEDBACK</div>
                              <div style={{fontSize:12,color:"#ccc",lineHeight:1.6}}>{s.mentorFeedback}</div>
                            </div>
                          )}
                          {s.tasksCasa&&(
                            <div style={{background:"rgba(212,175,55,0.05)",border:"1px solid rgba(212,175,55,0.15)",borderRadius:8,padding:"8px 12px"}}>
                              <div style={{fontSize:9,color:GOLD,letterSpacing:2,marginBottom:4}}>TASKURI ACASĂ</div>
                              <div style={{fontSize:12,color:"#ccc",lineHeight:1.6}}>{s.tasksCasa}</div>
                            </div>
                          )}
                          {s.studentFeedback&&(
                            <div style={{background:"rgba(52,152,219,0.05)",border:"1px solid rgba(52,152,219,0.15)",borderRadius:8,padding:"8px 12px"}}>
                              <div style={{fontSize:9,color:"#3498DB",letterSpacing:2,marginBottom:4}}>RĂSPUNS CURSANT</div>
                              <div style={{fontSize:12,color:"#ccc",lineHeight:1.6,fontStyle:"italic"}}>"{s.studentFeedback}"</div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <button onClick={()=>{setJurnalSes(s);setJurnalF({mentorFeedback:s.mentorFeedback||"",tasksCasa:s.tasksCasa||"",observatii:""});}} className="btn gh sm" style={{flexShrink:0}}>
                      {hasJurnal?"✏️":"📝"}
                    </button>
                  </div>
                </div>
              );
            })}
            {allSessions.filter(s=>s.status==="completed"&&!s.source).length===0&&(
              <div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Nicio ședință efectuată.</div>
            )}
          </>
        )}

        {/* VIDEO-URI CURSANȚI */}
        {view==="videos"&&(
          <>
            <div className="serif" style={{fontSize:22,color:"#9B59B6",marginBottom:14}}>🎬 Video-uri cursanți</div>
            {videos.length===0&&<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Niciun video uploadat de cursanți.</div>}
            {videos.map(v=>{
              const st=students.find(s=>s.id===v.studentId);
              return (
                <div key={v.id} className="card">
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,flexWrap:"wrap",marginBottom:8}}>
                    <div>
                      <div style={{fontSize:14,fontWeight:600,color:"#eee"}}>{st?.name||v.studentName||"—"}</div>
                      <div style={{fontSize:11,color:"#555"}}>{v.createdAt?.toDate?new Date(v.createdAt.toDate()).toLocaleDateString("ro-RO"):"—"}</div>
                    </div>
                    <Badge label={v.mentorReview?"Reviewat":"Nou"} color={v.mentorReview?"#2ECC71":"#E74C3C"}/>
                  </div>
                  {v.note&&<div style={{fontSize:12,color:"#888",marginBottom:8,fontStyle:"italic"}}>"{v.note}"</div>}
                  <a href={v.videoUrl} target="_blank" rel="noreferrer" style={{fontSize:13,color:"#3498DB",display:"block",marginBottom:10}}>🎬 {v.fileName||"Vizionează video"}</a>
                  {v.mentorReview&&<div style={{background:"rgba(46,204,113,0.05)",border:"1px solid rgba(46,204,113,0.15)",borderRadius:8,padding:"8px 12px",marginBottom:8}}><div style={{fontSize:10,color:"#2ECC71",marginBottom:3}}>REVIEW TĂU</div><div style={{fontSize:12,color:"#aaa"}}>{v.mentorReview}</div></div>}
                  {!v.mentorReview&&(
                    <button onClick={()=>{setRevMod({type:"video",id:v.id,studentId:v.studentId});setRevText("");}} className="btn gh-g sm">📝 Adaugă review</button>
                  )}
                </div>
              );
            })}
          </>
        )}

        {/* ── OBIECTIVE MENTOR ── */}
        {view==="obiective"&&(
          <>
            <div className="serif" style={{fontSize:22,color:"#F39C12",marginBottom:14}}>🎯 Obiective Cursanți</div>
            <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:10,marginBottom:14,WebkitOverflowScrolling:"touch"}}>
              {students.map(s=>(
                <button key={s.id} onClick={()=>setObStudent(s)} style={{flexShrink:0,padding:"8px 14px",borderRadius:10,background:obStudent?.id===s.id?"rgba(243,156,18,0.15)":"rgba(255,255,255,0.03)",border:`1px solid ${obStudent?.id===s.id?"rgba(243,156,18,0.4)":BORDER}`,color:obStudent?.id===s.id?"#F39C12":"#666",fontSize:13,cursor:"pointer",whiteSpace:"nowrap",fontFamily:"'DM Sans',sans-serif",minHeight:40}}>
                  {s.name}
                </button>
              ))}
            </div>
            {obStudent?(
              <>
                <div className="card" style={{borderColor:"rgba(243,156,18,0.2)",marginBottom:12}}>
                  <div style={{fontSize:11,color:"#F39C12",letterSpacing:1,marginBottom:10}}>+ OBIECTIV NOU PENTRU {obStudent.name.toUpperCase()}</div>
                  <div style={{display:"flex",flexDirection:"column",gap:8}}>
                    <input value={obF.text} onChange={e=>setObF(f=>({...f,text:e.target.value}))} placeholder="Ex: Exersează beatmatching 15min/zi" className="fi"/>
                    <div style={{display:"flex",gap:8}}>
                      <input type="date" value={obF.deadline} onChange={e=>setObF(f=>({...f,deadline:e.target.value}))} className="fi" style={{flex:1}}/>
                      <input value={obF.notes} onChange={e=>setObF(f=>({...f,notes:e.target.value}))} placeholder="Note extra (opțional)" className="fi" style={{flex:2}}/>
                    </div>
                    <button onClick={addObiectiv} disabled={obSaving} className="btn full" style={{background:"rgba(243,156,18,0.15)",border:"1px solid rgba(243,156,18,0.3)",color:"#F39C12",borderRadius:10,padding:"10px",fontSize:13,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>
                      {obSaving?"Se salvează...":"🎯 Adaugă obiectiv"}
                    </button>
                  </div>
                </div>
                {obStudentData.length===0&&<div style={{textAlign:"center",color:"#444",padding:24,fontSize:13}}>Niciun obiectiv setat pentru {obStudent.name}.</div>}
                {obStudentData.map(ob=>(
                  <div key={ob.id} className="card" style={{borderColor:ob.done?"rgba(46,204,113,0.2)":BORDER}}>
                    <div style={{display:"flex",alignItems:"flex-start",gap:10}}>
                      <div style={{width:26,height:26,borderRadius:7,background:ob.done?"#2ECC71":"rgba(255,255,255,0.05)",border:`1px solid ${ob.done?"#2ECC71":BORDER}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,color:ob.done?"#fff":"#333",flexShrink:0}}>{ob.done?"✓":""}</div>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:14,color:ob.done?"#2ECC71":"#eee",fontWeight:600,textDecoration:ob.done?"line-through":"none"}}>{ob.text}</div>
                        {ob.deadline&&<div style={{fontSize:11,color:"#555",marginTop:2}}>📅 Termen: {ob.deadline}</div>}
                        {ob.notes&&<div style={{fontSize:12,color:"#888",marginTop:3,fontStyle:"italic"}}>{ob.notes}</div>}
                        <div style={{fontSize:10,color:"#333",marginTop:3}}>{ob.done?"✓ Realizat de cursant":"În așteptare"}</div>
                      </div>
                      <button onClick={()=>deleteObiectiv(ob.id)} className="btn gh-r sm" style={{flexShrink:0,minHeight:28,padding:"4px 8px"}}>🗑</button>
                    </div>
                  </div>
                ))}
              </>
            ):<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Selectează un cursant.</div>}
          </>
        )}

        {/* ── PLAYLIST MENTOR ── */}
        {view==="playlist"&&(
          <>
            <div className="serif" style={{fontSize:22,color:"#2ECC71",marginBottom:14}}>🎵 Playlist-urile cursanților</div>
            <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:10,marginBottom:14,WebkitOverflowScrolling:"touch"}}>
              {students.map(s=>(
                <button key={s.id} onClick={()=>setPlStudent(s)} style={{flexShrink:0,padding:"8px 14px",borderRadius:10,background:plStudent?.id===s.id?"rgba(46,204,113,0.15)":"rgba(255,255,255,0.03)",border:`1px solid ${plStudent?.id===s.id?"rgba(46,204,113,0.4)":BORDER}`,color:plStudent?.id===s.id?"#2ECC71":"#666",fontSize:13,cursor:"pointer",whiteSpace:"nowrap",fontFamily:"'DM Sans',sans-serif",minHeight:40}}>
                  {s.name}
                </button>
              ))}
            </div>
            {plStudent?(
              <>
                {plData.length===0&&<div style={{textAlign:"center",color:"#444",padding:24,fontSize:13}}>{plStudent.name} nu a adăugat piese încă.</div>}
                {plData.map((t,i)=>(
                  <div key={t.id} className="card" style={{padding:"12px 14px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:12}}>
                      <div style={{width:34,height:34,borderRadius:8,background:"rgba(46,204,113,0.1)",border:"1px solid rgba(46,204,113,0.2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,color:"#2ECC71",fontWeight:700,flexShrink:0}}>{i+1}</div>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:14,fontWeight:600,color:"#eee"}} className="trunc">{t.title}</div>
                        <div style={{fontSize:11,color:"#555",marginTop:2}}>{[t.artist,t.bpm&&`${t.bpm} BPM`].filter(Boolean).join(" · ")}</div>
                        {t.notes&&<div style={{fontSize:11,color:"#888",marginTop:2,fontStyle:"italic"}}>{t.notes}</div>}
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ):<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Selectează un cursant.</div>}
          </>
        )}

        {/* ── MIX-URI MENTOR ── */}
        {view==="mixes"&&(
          <>
            <div className="serif" style={{fontSize:22,color:"#9B59B6",marginBottom:14}}>🎚️ Mix-urile cursanților</div>
            <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:10,marginBottom:14,WebkitOverflowScrolling:"touch"}}>
              {students.map(s=>(
                <button key={s.id} onClick={()=>setMixStudent(s)} style={{flexShrink:0,padding:"8px 14px",borderRadius:10,background:mixStudent?.id===s.id?"rgba(155,89,182,0.15)":"rgba(255,255,255,0.03)",border:`1px solid ${mixStudent?.id===s.id?"rgba(155,89,182,0.4)":BORDER}`,color:mixStudent?.id===s.id?"#9B59B6":"#666",fontSize:13,cursor:"pointer",whiteSpace:"nowrap",fontFamily:"'DM Sans',sans-serif",minHeight:40}}>
                  {s.name}
                </button>
              ))}
            </div>
            {mixStudent?(
              <>
                {mixStudentData.length===0&&<div style={{textAlign:"center",color:"#444",padding:24,fontSize:13}}>{mixStudent.name} nu a adăugat mix-uri încă.</div>}
                {mixStudentData.map(m=>(
                  <div key={m.id} className="card">
                    <div style={{display:"flex",alignItems:"flex-start",gap:12}}>
                      <div style={{width:44,height:44,borderRadius:10,background:"rgba(155,89,182,0.15)",border:"1px solid rgba(155,89,182,0.25)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>🎚️</div>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:14,fontWeight:600,color:"#eee"}}>{m.title}</div>
                        {m.description&&<div style={{fontSize:12,color:"#888",marginTop:3}}>{m.description}</div>}
                        <div style={{fontSize:10,color:"#444",marginTop:4}}>{m.createdAt?.toDate?new Date(m.createdAt.toDate()).toLocaleDateString("ro-RO"):""}</div>
                        {m.url&&<a href={m.url} target="_blank" rel="noreferrer" style={{fontSize:13,color:"#9B59B6",display:"inline-block",marginTop:6,fontWeight:500}}>▶ Ascultă / Descarcă</a>}
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ):<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Selectează un cursant pentru a vedea mix-urile lui.</div>}
          </>
        )}

        {/* CHAT */}
        {view==="chat"&&(
          <>
            <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:10,marginBottom:14,WebkitOverflowScrolling:"touch"}}>
              {students.map(s=>(
                <button key={s.id} onClick={()=>setChatSt(s)} style={{flexShrink:0,padding:"8px 14px",borderRadius:10,background:chatSt?.id===s.id?"rgba(52,152,219,0.15)":"rgba(255,255,255,0.03)",border:`1px solid ${chatSt?.id===s.id?"rgba(52,152,219,0.4)":BORDER}`,color:chatSt?.id===s.id?"#3498DB":"#666",fontSize:13,fontWeight:chatSt?.id===s.id?600:400,cursor:"pointer",whiteSpace:"nowrap",fontFamily:"'DM Sans',sans-serif",minHeight:40}}>
                  {s.name}
                </button>
              ))}
              {students.length===0&&<div style={{fontSize:12,color:"#444"}}>Niciun cursant asignat.</div>}
            </div>
            {chatSt?(
              <div className="chat-wrap" style={{background:"rgba(255,255,255,0.02)"}}>
                <div style={{padding:"12px 14px",borderBottom:`1px solid ${BORDER}`,fontSize:14,fontWeight:600,color:"#eee",flexShrink:0}}>{chatSt.name}</div>
                <div className="chat-msgs">
                  {chatMsgs.map(m=>(
                    <div key={m.id} style={{alignSelf:m.senderId===user.uid?"flex-end":"flex-start",background:m.senderId===user.uid?"rgba(52,152,219,0.15)":"rgba(255,255,255,0.04)",border:`1px solid ${m.senderId===user.uid?"rgba(52,152,219,0.25)":BORDER}`,borderRadius:10,padding:"8px 12px",maxWidth:"80%"}}>
                      <div style={{fontSize:13,color:"#eee"}}>{m.text}</div>
                      <div style={{fontSize:9,color:"#444",marginTop:4}}>{fmtDt(m.createdAt)}</div>
                    </div>
                  ))}
                  {chatMsgs.length===0&&<div style={{textAlign:"center",color:"#444",fontSize:12,marginTop:30}}>Niciun mesaj.</div>}
                  <div ref={chatEnd}/>
                </div>
                <div className="chat-in">
                  <input className="chat-field" value={chatMsg} onChange={e=>setChatMsg(e.target.value)} onKeyDown={e=>e.key==="Enter"&&sendMsg()} placeholder="Scrie un mesaj..."/>
                  <button onClick={sendMsg} className="btn blue" style={{padding:"10px 14px",flexShrink:0,minHeight:44}}>Trimite</button>
                </div>
              </div>
            ):<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Selectează un cursant.</div>}
          </>
        )}

      </div>
      <BottomNav items={navItems} active={view} onChange={setView} onLogout={onLogout}/>

      {/* Review modal */}
      <Modal open={!!revMod} onClose={()=>setRevMod(null)}>
        <div className="serif" style={{fontSize:20,color:GOLD,marginBottom:14}}>📝 Review</div>
        <F label="Feedback pentru cursant" multiline value={revText} onChange={e=>setRevText(e.target.value)} rows={5} placeholder="Scrie feedback-ul..."/>
        <button onClick={()=>addReview(revMod?.id)} className="btn gold full">Salvează review</button>
      </Modal>

      {/* MODAL JURNAL MENTOR */}
      <Modal open={!!jurnalSes} onClose={()=>setJurnalSes(null)}>
        <div className="serif" style={{fontSize:20,color:GOLD,marginBottom:8}}>📓 Jurnal Ședință</div>
        {jurnalSes&&(
          <div style={{fontSize:12,color:"#555",marginBottom:14}}>
            {students.find(x=>x.id===jurnalSes.studentId)?.name||"Cursant"} · {jurnalSes.date} · {jurnalSes.time}
          </div>
        )}
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <div>
            <div style={{fontSize:11,color:"#2ECC71",letterSpacing:1,marginBottom:6}}>FEEDBACK (vizibil cursantului)</div>
            <textarea value={jurnalF.mentorFeedback} onChange={e=>setJurnalF(f=>({...f,mentorFeedback:e.target.value}))}
              placeholder="Ce a mers bine, ce trebuie îmbunătățit..."
              rows={4} style={{width:"100%",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(46,204,113,0.25)",borderRadius:10,padding:"10px 14px",color:"#eee",fontSize:13,resize:"vertical",outline:"none"}}/>
          </div>
          <div>
            <div style={{fontSize:11,color:GOLD,letterSpacing:1,marginBottom:6}}>TASKURI ACASĂ (vizibil cursantului)</div>
            <textarea value={jurnalF.tasksCasa} onChange={e=>setJurnalF(f=>({...f,tasksCasa:e.target.value}))}
              placeholder="Ex: Exersează beatmatching 15min/zi..."
              rows={3} style={{width:"100%",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(212,175,55,0.25)",borderRadius:10,padding:"10px 14px",color:"#eee",fontSize:13,resize:"vertical",outline:"none"}}/>
          </div>
          <button onClick={saveJurnal} disabled={jurnalSaving} className="btn gold full">
            {jurnalSaving?"Se salvează...":"💾 Salvează jurnalul"}
          </button>
        </div>
      </Modal>

      {/* MODAL EDITARE ȘEDINȚĂ */}
      <Modal open={!!sesEditMod} onClose={()=>setSesEditMod(null)}>
        <div className="serif" style={{fontSize:20,color:GOLD,marginBottom:14}}>✏️ Editează ședința</div>
        {sesEditMod&&(
          <div style={{fontSize:12,color:"#555",marginBottom:14}}>
            {students.find(x=>x.id===sesEditMod.studentId)?.name||"Cursant"} · status: {sesEditMod.status}
          </div>
        )}
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          <div style={{display:"flex",gap:8}}>
            <div style={{flex:1}}>
              <label style={{fontSize:11,color:"#555",display:"block",marginBottom:4}}>Data</label>
              <input type="date" value={sesEditF.date} onChange={e=>setSesEditF(f=>({...f,date:e.target.value}))} className="fi"/>
            </div>
            <div style={{flex:1}}>
              <label style={{fontSize:11,color:"#555",display:"block",marginBottom:4}}>Ora</label>
              <input type="time" value={sesEditF.time} onChange={e=>setSesEditF(f=>({...f,time:e.target.value}))} className="fi"/>
            </div>
          </div>
          <div>
            <label style={{fontSize:11,color:"#555",display:"block",marginBottom:4}}>Locație</label>
            <input value={sesEditF.location} onChange={e=>setSesEditF(f=>({...f,location:e.target.value}))} placeholder="DJ School Studio" className="fi"/>
          </div>
          <div>
            <label style={{fontSize:11,color:"#555",display:"block",marginBottom:4}}>Note</label>
            <textarea value={sesEditF.notes} onChange={e=>setSesEditF(f=>({...f,notes:e.target.value}))} rows={3} className="fi" style={{resize:"vertical"}}/>
          </div>
          <div>
            <label style={{fontSize:11,color:"#555",display:"block",marginBottom:4}}>Link video (opțional)</label>
            <input value={sesEditF.videoUrl} onChange={e=>setSesEditF(f=>({...f,videoUrl:e.target.value}))} placeholder="https://..." className="fi"/>
          </div>
          <button onClick={saveSesEdit} disabled={sesEditSaving} className="btn gold full">
            {sesEditSaving?"Se salvează...":"💾 Salvează modificările"}
          </button>
        </div>
      </Modal>
    </div>
  );
}

// ════════════════════════════════════════════════
// STUDENT DASHBOARD
// ════════════════════════════════════════════════
function StudentDashboard({ user, onLogout, toast }) {
  const [view,setView]=useState("home");
  const [sessions,setSessions]=useState([]);
  const [curriculum,setCurriculum]=useState([]);
  const [mentor,setMentor]=useState(null);
  const [chatMsgs,setChatMsgs]=useState([]);
  const [chatMsg,setChatMsg]=useState("");
  const [qrUrl,setQrUrl]=useState("");
  const [upMod,setUpMod]=useState(false);
  const [upFile,setUpFile]=useState(null);
  const [upNote,setUpNote]=useState("");
  const [uploading,setUploading]=useState(false);
  const chatEnd=useRef(null);
  const [myVideos,setMyVideos]=useState([]);
  // ── NOU: Playlist ──
  const [playlist,setPlaylist]=useState([]);
  const [trackF,setTrackF]=useState({title:"",artist:"",bpm:"",notes:""});
  const [showAddTrack,setShowAddTrack]=useState(false);
  // ── NOU: Obiective ──
  const [obiective,setObiective]=useState([]);
  // ── NOU: Streak ──
  const [streakData,setStreakData]=useState({days:[],streak:0});
  // ── NOU: Mix Gallery ──
  const [mixGallery,setMixGallery]=useState([]);
  const [mixMod,setMixMod]=useState(false);
  const [mixFile,setMixFile]=useState(null);
  const [mixTitle,setMixTitle]=useState("");
  const [mixDesc,setMixDesc]=useState("");
  const [mixUploading,setMixUploading]=useState(false);
  // ── NOU: Note personale ──
  const [noteSes,setNoteSes]=useState(null);
  const [noteText,setNoteText]=useState("");
  const [noteSaving,setNoteSaving]=useState(false);

  // Programari confirmate din booking app
  const bookingAppointments=useBookingAppointments(user.email,"student");

  const pkg=(user.package||"").toLowerCase();
  const isPrem=pkg.includes("premium")||pkg.includes("imagine");
  const isPlus=pkg.includes("plus")||pkg.includes("club ready");
  const maxMod=isPrem?12:isPlus?10:8;
  const pkgName=isPrem?"Premium":isPlus?"Plus":"Standard";
  const pkgColor=isPrem?"#9B59B6":isPlus?"#3498DB":GOLD;
  const filt=curriculum.slice(0,maxMod);
  const allL=filt.reduce((a,m)=>a+(m.lessons||[]).length,0);
  const doneL=filt.reduce((a,m)=>a+(m.lessons||[]).filter(l=>(user.completedLessons||[]).includes(l.id)).length,0);
  const prog=allL>0?Math.round(doneL/allL*100):0;

  useEffect(()=>{
    const u1=onSnapshot(query(collection(db,"school_sessions"),where("studentId","==",user.uid)),s=>setSessions(s.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>(b.date||"").localeCompare(a.date||""))));
    const u2=onSnapshot(query(collection(db,"school_curriculum"),orderBy("order","asc")),s=>setCurriculum(s.docs.map(d=>({id:d.id,...d.data()}))));
    if(user.mentorId)getDoc(doc(db,"school_users",user.mentorId)).then(d=>{if(d.exists())setMentor({id:d.id,...d.data()});});
    QRCode.toDataURL(user.uid,{width:260,margin:2,color:{dark:GOLD,light:DARK}}).then(setQrUrl);
    const u3=onSnapshot(query(collection(db,"school_playlist"),where("studentId","==",user.uid)),s=>setPlaylist(s.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>(b.createdAt?.seconds||0)-(a.createdAt?.seconds||0))));
    const u4=onSnapshot(query(collection(db,"school_obiective"),where("studentId","==",user.uid)),s=>setObiective(s.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>(a.createdAt?.seconds||0)-(b.createdAt?.seconds||0))));
    const u5=onSnapshot(doc(db,"school_streak",user.uid),snap=>{if(snap.exists()){const d=snap.data();setStreakData({days:d.days||[],streak:d.currentStreak||0});}});
    const u6=onSnapshot(query(collection(db,"school_mixes"),where("studentId","==",user.uid)),s=>setMixGallery(s.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>(b.createdAt?.seconds||0)-(a.createdAt?.seconds||0))));
    const u7=onSnapshot(query(collection(db,"school_student_videos"),where("studentId","==",user.uid)),s=>setMyVideos(s.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>(b.createdAt?.seconds||0)-(a.createdAt?.seconds||0))));
    return()=>{u1();u2();u3();u4();u5();u6();u7();};
  },[user.uid,user.mentorId]);

  useEffect(()=>{
    if(!mentor)return;
    const chatId=[user.uid,mentor.id].sort().join("_");
    return onSnapshot(query(collection(db,"school_chats",chatId,"messages"),orderBy("createdAt","asc")),s=>{
      setChatMsgs(s.docs.map(d=>({id:d.id,...d.data()})));
      setTimeout(()=>chatEnd.current?.scrollIntoView({behavior:"smooth"}),100);
    });
  },[mentor,user.uid]);

  const sendMsg=async()=>{
    if(!chatMsg.trim()||!mentor)return;
    const chatId=[user.uid,mentor.id].sort().join("_");
    await addDoc(collection(db,"school_chats",chatId,"messages"),{text:chatMsg.trim(),senderId:user.uid,senderName:user.name,createdAt:serverTimestamp()});
    setChatMsg("");
  };

  const uploadVideo=async()=>{
    if(!upFile){toast("Selectează un fișier.","error");return;}
    setUploading(true);
    try{
      const sRef=ref(storage,`school_videos/${user.uid}/${Date.now()}_${upFile.name}`);
      await uploadBytes(sRef,upFile);
      const url=await getDownloadURL(sRef);
      await addDoc(collection(db,"school_student_videos"),{
        studentId:user.uid,studentName:user.name,
        mentorId:user.mentorId||null, // IMPORTANT: atribuim mentorului
        videoUrl:url,note:upNote,fileName:upFile.name,
        createdAt:serverTimestamp(),reviewed:false
      });
      toast("Video uploadat! Mentorul va lăsa un review.","success");
      setUpMod(false);setUpFile(null);setUpNote("");
    }catch(e){toast("Eroare: "+e.message,"error");}
    setUploading(false);
  };

  const addTrack=async()=>{
    if(!trackF.title){toast("Titlu obligatoriu.","error");return;}
    await addDoc(collection(db,"school_playlist"),{...trackF,studentId:user.uid,studentName:user.name,mentorId:user.mentorId||null,createdAt:serverTimestamp()});
    setTrackF({title:"",artist:"",bpm:"",notes:""});setShowAddTrack(false);
    toast("Piesă adăugată!","success");
  };
  const removeTrack=async(id)=>await deleteDoc(doc(db,"school_playlist",id));

  const markPractice=async()=>{
    const azi=new Date().toISOString().split("T")[0];
    const days=streakData.days||[];
    if(days.includes(azi)){toast("Deja marcat azi!","info");return;}
    const newDays=[...days,azi].sort();
    let streak=1;
    const sorted=[...newDays].sort().reverse();
    for(let i=0;i<sorted.length-1;i++){
      const diff=(new Date(sorted[i])-new Date(sorted[i+1]))/86400000;
      if(diff===1)streak++;else break;
    }
    await setDoc(doc(db,"school_streak",user.uid),{days:newDays,currentStreak:streak,studentId:user.uid,updatedAt:serverTimestamp()},{merge:true});
    toast(`🔥 Zi marcată! Streak: ${streak} zile`,"success");
  };

  const uploadMix=async()=>{
    if(!mixTitle){toast("Titlu obligatoriu.","error");return;}
    setMixUploading(true);
    try{
      let url="";
      if(mixFile){
        const sRef=ref(storage,`school_mixes/${user.uid}/${Date.now()}_${mixFile.name}`);
        await uploadBytes(sRef,mixFile);url=await getDownloadURL(sRef);
      }
      await addDoc(collection(db,"school_mixes"),{studentId:user.uid,studentName:user.name,mentorId:user.mentorId||null,title:mixTitle,description:mixDesc,url,fileName:mixFile?.name||"",createdAt:serverTimestamp()});
      toast("Mix adăugat!","success");
      setMixMod(false);setMixFile(null);setMixTitle("");setMixDesc("");
    }catch(e){toast("Eroare: "+e.message,"error");}
    setMixUploading(false);
  };

  const saveNota=async()=>{
    if(!noteSes)return;setNoteSaving(true);
    try{
      await updateDoc(doc(db,"school_sessions",noteSes.id),{notaPersonala:noteText,notaUpdatedAt:serverTimestamp()});
      toast("Notă salvată!","success");setNoteSes(null);
    }catch(e){toast("Eroare: "+e.message,"error");}
    setNoteSaving(false);
  };

  // Toate sesiunile: school_sessions + booking confirmat
  const allSessions=[
    ...sessions,
    ...bookingAppointments.map(a=>({
      id:"booking_"+a.id,
      date:a.date,
      time:a.time,
      location:a.location||"Booking App",
      status:"scheduled",
      source:"booking",
      notes:a.notes||""
    }))
  ].sort((a,b)=>b.date?.localeCompare(a.date)||0);

  const navItems=[
    {id:"home",      icon:"◆", label:"Acasă"},
    {id:"curriculum",icon:"📋",label:"Programă"},
    {id:"sessions",  icon:"📅",label:"Ședințe"},
    {id:"jurnal",    icon:"📓",label:"Jurnal"},
    {id:"resurse",   icon:"📚",label:"Resurse"},
    {id:"videos",    icon:"🎬",label:"Video"},
    {id:"playlist",  icon:"🎵",label:"Playlist"},
    {id:"obiective", icon:"🎯",label:"Obiective"},
    {id:"streak",    icon:"🔥",label:"Streak"},
    {id:"mixes",     icon:"🎚️",label:"Mix-uri"},
    {id:"chat",      icon:"💬",label:"Chat"},
    {id:"qr",        icon:"⬡", label:"QR"},
  ];

  // State pentru feedback cursant
  const [feedbackSes,setFeedbackSes]=useState(null);
  const [feedbackText,setFeedbackText]=useState("");
  const [feedbackSaving,setFeedbackSaving]=useState(false);
  const [studentResources,setStudentResources]=useState([]);

  useEffect(()=>{
    const u=onSnapshot(collection(db,"school_resources"),s=>
      setStudentResources(s.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>Number(a.lessonNumber)-Number(b.lessonNumber))));
    return()=>u();
  },[]);

  const saveStudentFeedback=async()=>{
    if(!feedbackSes)return;
    setFeedbackSaving(true);
    try{
      await updateDoc(doc(db,"school_sessions",feedbackSes.id),{
        studentFeedback:feedbackText,
        studentFeedbackAt:serverTimestamp(),
      });
      toast("Răspuns salvat!","success");
      setFeedbackSes(null);
    }catch(e){toast("Eroare: "+e.message,"error");}
    setFeedbackSaving(false);
  };

  return (
    <div className="shell" style={{background:DARK}}>
      <style>{CSS}</style>
      <TopBar
        left={<div><div className="serif gt" style={{fontSize:16,fontWeight:600}}>DJ School</div><div style={{fontSize:9,color:"#333",letterSpacing:2}} className="trunc">{user.name}</div></div>}
        center={<span style={{fontSize:10,padding:"2px 8px",borderRadius:20,background:`${pkgColor}20`,color:pkgColor,border:`1px solid ${pkgColor}40`,fontWeight:600}}>{pkgName}</span>}
        right={<button onClick={onLogout} className="btn gh sm">⎋</button>}
      />
      <Sidebar items={navItems} active={view} onChange={setView} onLogout={onLogout} user={user} accent="sg">
        <div style={{marginTop:10}}>
          <span style={{fontSize:10,padding:"2px 8px",borderRadius:20,background:`${pkgColor}20`,color:pkgColor,border:`1px solid ${pkgColor}40`,fontWeight:600}}>{pkgName}</span>
          <div className="pt" style={{marginTop:8}}><div className="pf" style={{width:`${prog}%`,background:`linear-gradient(90deg,${GOLD},#F5D76E)`}}/></div>
          <div style={{fontSize:10,color:GOLD,marginTop:4}}>{prog}% completat</div>
        </div>
      </Sidebar>

      <div className="scroll fu">

        {/* HOME */}
        {view==="home"&&(
          <>
            <div className="serif gt" style={{fontSize:24,fontWeight:600,marginBottom:2}}>Bun venit, {user.name?.split(" ")[0]}!</div>
            <div style={{fontSize:12,color:"#444",marginBottom:16}}>Privilege DJ School</div>
            <div className="sg">
              {[
                {label:"Progres",  value:`${prog}%`,                                    color:GOLD},
                {label:"Efectuate",value:sessions.filter(s=>s.status==="completed").length,color:"#2ECC71"},
                {label:"Ședințe",  value:allSessions.length,                             color:"#3498DB"},
                {label:"Lecții",   value:doneL,                                           color:"#9B59B6"},
              ].map(s=>(
                <div key={s.label} className="card">
                  <div className="serif" style={{fontSize:28,fontWeight:700,color:s.color}}>{s.value}</div>
                  <div style={{fontSize:11,color:"#555",marginTop:3}}>{s.label}</div>
                </div>
              ))}
            </div>
            {/* Programeaza o sedinta prin Booking App */}
            <div className="card" style={{borderColor:"rgba(212,175,55,0.2)",marginBottom:12}}>
              <div style={{fontSize:10,color:GOLD,letterSpacing:2,marginBottom:8}}>📌 PROGRAMEAZĂ O ȘEDINȚĂ</div>
              <div style={{fontSize:13,color:"#888",marginBottom:10}}>Intră pe platforma de booking și selectează:</div>
              <div style={{background:"rgba(212,175,55,0.06)",border:"1px solid rgba(212,175,55,0.15)",borderRadius:10,padding:"10px 14px",marginBottom:14}}>
                <div style={{fontSize:12,color:"#eee",marginBottom:4}}>🎬 <strong style={{color:GOLD}}>Privilege Studio</strong></div>
                <div style={{fontSize:11,color:"#888"}}>→ Tip sesiune: <span style={{color:"#eee",fontWeight:600}}>Ședință Cursant DJ School</span></div>
              </div>
              <a href="https://bookings.privilegeagency.eu/" target="_blank" rel="noreferrer" className="btn gold" style={{display:"flex",justifyContent:"center",textDecoration:"none"}}>
                📅 Deschide Booking App
              </a>
            </div>
            {mentor&&(
              <div className="card" style={{borderColor:"rgba(52,152,219,0.2)",marginBottom:12}}>
                <div style={{fontSize:10,color:"#3498DB",letterSpacing:2,marginBottom:8}}>MENTORUL TĂU</div>
                <div style={{fontSize:15,fontWeight:600,color:"#eee"}}>🎧 {mentor.name}</div>
                {mentor.bio&&<div style={{fontSize:12,color:"#555",marginTop:6}}>{mentor.bio}</div>}
                <button onClick={()=>setView("chat")} className="btn gh-b sm" style={{marginTop:12}}>💬 Deschide chat</button>
              </div>
            )}
            {allSessions.filter(s=>s.status==="scheduled").length>0&&(()=>{
              const next=allSessions.filter(s=>s.status==="scheduled").slice(-1)[0];
              return (
                <div className="card" style={{borderColor:"rgba(212,175,55,0.2)"}}>
                  <div style={{fontSize:10,color:GOLD,letterSpacing:2,marginBottom:8}}>URMĂTOAREA ȘEDINȚĂ</div>
                  <div style={{fontSize:16,fontWeight:600,color:"#eee"}}>{next.date} · {next.time}</div>
                  <div style={{fontSize:12,color:"#555",marginTop:4}}>{next.location}</div>
                  {next.source==="booking"&&<div style={{fontSize:10,color:GOLD,marginTop:4}}>📌 Confirmat în Booking App</div>}
                </div>
              );
            })()}
          </>
        )}

        {/* CURRICULUM */}
        {view==="curriculum"&&(
          <>
            <div className="serif gt" style={{fontSize:22,fontWeight:600,marginBottom:4}}>📋 Programa ta</div>
            <div style={{fontSize:11,color:"#444",marginBottom:14}}>Privilege DJ School</div>
            <div className="card" style={{borderColor:`${pkgColor}30`,marginBottom:14,display:"flex",alignItems:"center",gap:12}}>
              <div style={{width:38,height:38,borderRadius:10,background:`${pkgColor}20`,border:`1px solid ${pkgColor}40`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>{isPrem?"👑":isPlus?"🎯":"✦"}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,color:pkgColor,fontWeight:600}}>{pkgName}</div>
                <div style={{fontSize:11,color:"#444",marginTop:2}}>{maxMod} ședințe · {allL} lecții</div>
              </div>
              <div style={{textAlign:"right",flexShrink:0}}>
                <div className="serif" style={{fontSize:24,fontWeight:700,color:prog===100?"#2ECC71":pkgColor}}>{prog}%</div>
                <div style={{fontSize:10,color:"#444"}}>{doneL}/{allL}</div>
              </div>
            </div>
            <div className="pt" style={{marginBottom:16}}><div className="pf" style={{width:`${prog}%`,background:`linear-gradient(90deg,${pkgColor},${pkgColor}88)`}}/></div>
            {filt.map((mod,idx)=>{
              const tot=(mod.lessons||[]).length;
              const dn=(mod.lessons||[]).filter(l=>(user.completedLessons||[]).includes(l.id)).length;
              const p=tot>0?Math.round(dn/tot*100):0;
              return (
                <div key={mod.id} className="card" style={{borderColor:p===100?"rgba(46,204,113,0.2)":BORDER}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:10,color:GOLD,letterSpacing:2}}>ȘEDINȚA {idx+1}</div>
                      <div style={{fontSize:14,fontWeight:600,color:"#eee",marginTop:2}}>{mod.title}</div>
                    </div>
                    <div style={{textAlign:"right",flexShrink:0,marginLeft:10}}>
                      <div className="serif" style={{fontSize:20,fontWeight:700,color:p===100?"#2ECC71":GOLD}}>{p}%</div>
                    </div>
                  </div>
                  <div className="pt" style={{marginBottom:10}}><div className="pf" style={{width:`${p}%`,background:p===100?"#2ECC71":GOLD}}/></div>
                  {(mod.lessons||[]).map((l,li)=>{
                    const isDone=(user.completedLessons||[]).includes(l.id);
                    return (
                      <div key={l.id} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 0",borderTop:li>0?`1px solid ${BORDER}`:"none",minHeight:44}}>
                        <div style={{width:22,height:22,borderRadius:6,background:isDone?"#2ECC71":"rgba(255,255,255,0.04)",border:`1px solid ${isDone?"#2ECC71":BORDER}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,color:isDone?"#fff":"#333",flexShrink:0}}>{isDone?"✓":li+1}</div>
                        <div style={{fontSize:13,color:isDone?"#2ECC71":"#ccc",flex:1}}>{l.title}</div>
                        <div style={{fontSize:10,color:"#333",flexShrink:0}}>{l.duration}m</div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
            {curriculum.slice(maxMod).length>0&&(
              <div style={{background:"rgba(255,255,255,0.01)",border:`1px solid rgba(255,255,255,0.04)`,borderRadius:14,padding:"20px 16px",textAlign:"center"}}>
                <div style={{fontSize:24,marginBottom:8}}>🔒</div>
                <div style={{fontSize:13,color:"#444",marginBottom:4}}>{curriculum.slice(maxMod).length} module suplimentare</div>
                <div style={{fontSize:11,color:"#333"}}>{!isPlus&&!isPrem?"Disponibile în pachetele Plus & Premium":"Disponibile în pachetul Premium"}</div>
              </div>
            )}
          </>
        )}

        {/* ȘEDINȚE */}
        {view==="sessions"&&(
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div className="serif" style={{fontSize:22,color:"#2ECC71"}}>📅 Ședințele mele</div>
              <a href="https://bookings.privilegeagency.eu/" target="_blank" rel="noreferrer" className="btn gh-g sm">📅 Programează</a>
            </div>
            {bookingAppointments.length>0&&(
              <div style={{background:"rgba(212,175,55,0.05)",border:`1px solid rgba(212,175,55,0.2)`,borderRadius:12,padding:"10px 14px",marginBottom:12}}>
                <div style={{fontSize:10,color:GOLD,letterSpacing:2,marginBottom:8}}>📌 PROGRAMĂRI CONFIRMATE (BOOKING APP)</div>
                {bookingAppointments.map(a=>(
                  <div key={a.id} style={{padding:"8px 0",borderBottom:`1px solid rgba(255,255,255,0.05)`}}>
                    <div style={{fontSize:13,color:"#eee",fontWeight:500}}>{a.date} · {a.time}</div>
                    <div style={{fontSize:11,color:"#555"}}>{a.location||"DJ School Studio"}</div>
                  </div>
                ))}
              </div>
            )}
            {allSessions.map(s=>(
              <div key={s.id} className="card" style={{borderColor:s.status==="completed"?"rgba(46,204,113,0.2)":BORDER}}>
                <div className="row-b">
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:14,fontWeight:600,color:"#eee"}}>{s.date} · {s.time}</div>
                    <div style={{fontSize:12,color:"#555"}}>{s.location}</div>
                    {s.source==="booking"&&<div style={{fontSize:10,color:GOLD,marginTop:3}}>📌 Confirmat Booking App</div>}
                    {s.videoUrl&&<a href={s.videoUrl} target="_blank" rel="noreferrer" style={{fontSize:12,color:"#3498DB",display:"block",marginTop:6}}>🎬 Video ședință</a>}
                    {s.mentorReview&&(
                      <div style={{marginTop:8,background:"rgba(46,204,113,0.05)",border:"1px solid rgba(46,204,113,0.15)",borderRadius:8,padding:"8px 12px"}}>
                        <div style={{fontSize:10,color:"#2ECC71",marginBottom:3}}>REVIEW MENTOR</div>
                        <div style={{fontSize:12,color:"#aaa"}}>{s.mentorReview}</div>
                      </div>
                    )}
                  </div>
                  <Badge label={s.status==="completed"?"Efectuată":"Programată"} color={s.status==="completed"?"#2ECC71":GOLD}/>
                </div>
              </div>
            ))}
            {allSessions.length===0&&<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Nicio ședință programată.</div>}
          </>
        )}

        {/* VIDEO-URI */}
        {view==="videos"&&(
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div className="serif" style={{fontSize:22,color:"#9B59B6"}}>🎬 Video-uri</div>
              <button onClick={()=>setUpMod(true)} className="btn pur sm">⬆ Upload</button>
            </div>
            {sessions.filter(s=>s.videoUrl).map(s=>(
              <div key={s.id} className="card">
                <div style={{fontSize:11,color:"#555",marginBottom:6}}>{s.date} · Video ședință</div>
                <a href={s.videoUrl} target="_blank" rel="noreferrer" style={{fontSize:14,color:"#3498DB",fontWeight:500}}>🎬 Vizionează înregistrarea</a>
                {s.mentorReview&&(
                  <div style={{marginTop:10,background:"rgba(46,204,113,0.05)",border:"1px solid rgba(46,204,113,0.15)",borderRadius:8,padding:"8px 12px"}}>
                    <div style={{fontSize:10,color:"#2ECC71",marginBottom:3}}>REVIEW MENTOR</div>
                    <div style={{fontSize:12,color:"#aaa"}}>{s.mentorReview}</div>
                  </div>
                )}
              </div>
            ))}
            {sessions.filter(s=>s.videoUrl).length===0&&(
              <div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>
                Niciun video de la mentor.<br/>
                <span style={{fontSize:11,color:"#333"}}>Poți uploada propriile video-uri pentru review.</span>
              </div>
            )}
          </>
        )}

        {/* CHAT */}
        {view==="chat"&&(
          <>
            <div className="serif" style={{fontSize:22,color:"#3498DB",marginBottom:14}}>💬 Chat {mentor?.name?`cu ${mentor.name}`:"Mentor"}</div>
            {mentor?(
              <div className="chat-wrap" style={{background:"rgba(255,255,255,0.02)"}}>
                <div className="chat-msgs">
                  {chatMsgs.map(m=>(
                    <div key={m.id} style={{alignSelf:m.senderId===user.uid?"flex-end":"flex-start",background:m.senderId===user.uid?`rgba(212,175,55,0.12)`:"rgba(255,255,255,0.04)",border:`1px solid ${m.senderId===user.uid?"rgba(212,175,55,0.25)":BORDER}`,borderRadius:10,padding:"8px 12px",maxWidth:"82%"}}>
                      <div style={{fontSize:13,color:"#eee"}}>{m.text}</div>
                      <div style={{fontSize:9,color:"#444",marginTop:4}}>{fmtDt(m.createdAt)}</div>
                    </div>
                  ))}
                  {chatMsgs.length===0&&<div style={{textAlign:"center",color:"#444",fontSize:12,marginTop:30}}>Niciun mesaj. Începe o conversație!</div>}
                  <div ref={chatEnd}/>
                </div>
                <div className="chat-in">
                  <input className="chat-field" value={chatMsg} onChange={e=>setChatMsg(e.target.value)} onKeyDown={e=>e.key==="Enter"&&sendMsg()} placeholder="Scrie un mesaj..."/>
                  <button onClick={sendMsg} className="btn gold" style={{padding:"10px 14px",flexShrink:0,minHeight:44}}>Trimite</button>
                </div>
              </div>
            ):<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Nu ai un mentor asignat.</div>}
          </>
        )}

        {/* QR */}
        {/* JURNAL CURSANT */}
        {view==="jurnal"&&(
          <>
            <div className="serif" style={{fontSize:22,color:GOLD,marginBottom:16}}>📓 Jurnalul meu</div>
            {allSessions.filter(s=>s.status==="completed").length===0&&(
              <div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>Nicio ședință efectuată încă.</div>
            )}
            {allSessions.filter(s=>s.status==="completed"&&!s.source).map(s=>(
              <div key={s.id} className="card" style={{borderColor:s.mentorFeedback?"rgba(46,204,113,0.2)":BORDER}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:s.mentorFeedback||s.tasksCasa?12:0}}>
                  <div>
                    <div style={{fontSize:13,fontWeight:600,color:"#eee"}}>{s.date} · {s.time}</div>
                    <div style={{fontSize:11,color:"#555",marginTop:2}}>{s.location}</div>
                  </div>
                  <Badge label="Efectuată" color="#2ECC71"/>
                </div>
                {s.mentorFeedback&&(
                  <div style={{background:"rgba(46,204,113,0.05)",border:"1px solid rgba(46,204,113,0.15)",borderRadius:8,padding:"10px 12px",marginBottom:8}}>
                    <div style={{fontSize:9,color:"#2ECC71",letterSpacing:2,marginBottom:5}}>FEEDBACK MENTOR</div>
                    <div style={{fontSize:13,color:"#ccc",lineHeight:1.7}}>{s.mentorFeedback}</div>
                  </div>
                )}
                {s.tasksCasa&&(
                  <div style={{background:"rgba(212,175,55,0.05)",border:"1px solid rgba(212,175,55,0.15)",borderRadius:8,padding:"10px 12px",marginBottom:8}}>
                    <div style={{fontSize:9,color:GOLD,letterSpacing:2,marginBottom:5}}>TASKURI ACASĂ</div>
                    <div style={{fontSize:13,color:"#ccc",lineHeight:1.7}}>{s.tasksCasa}</div>
                  </div>
                )}
                {!s.mentorFeedback&&!s.tasksCasa&&(
                  <div style={{fontSize:12,color:"#333",fontStyle:"italic"}}>Jurnalul nu a fost completat încă de mentor.</div>
                )}
                {/* Raspuns cursant */}
                {s.studentFeedback?(
                  <div style={{background:"rgba(52,152,219,0.05)",border:"1px solid rgba(52,152,219,0.15)",borderRadius:8,padding:"10px 12px",marginTop:6}}>
                    <div style={{fontSize:9,color:"#3498DB",letterSpacing:2,marginBottom:5}}>RĂSPUNSUL TĂU</div>
                    <div style={{fontSize:13,color:"#ccc",lineHeight:1.7}}>{s.studentFeedback}</div>
                  </div>
                ):(
                  s.mentorFeedback&&(
                    <button onClick={()=>{setFeedbackSes(s);setFeedbackText("");}} style={{marginTop:8,fontSize:11,color:"#3498DB",background:"rgba(52,152,219,0.08)",border:"1px solid rgba(52,152,219,0.2)",borderRadius:8,padding:"6px 12px",cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>
                      💬 Răspunde mentorului
                    </button>
                  )
                )}
                {s.notaPersonala?(
                  <div style={{background:"rgba(155,89,182,0.05)",border:"1px solid rgba(155,89,182,0.2)",borderRadius:8,padding:"10px 12px",marginTop:6}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                      <div style={{fontSize:9,color:"#9B59B6",letterSpacing:2}}>NOTA MEA</div>
                      <button onClick={()=>{setNoteSes(s);setNoteText(s.notaPersonala||"");}} style={{fontSize:10,color:"#9B59B6",background:"none",border:"none",cursor:"pointer",padding:0}}>✏️ Editează</button>
                    </div>
                    <div style={{fontSize:13,color:"#ccc",lineHeight:1.7}}>{s.notaPersonala}</div>
                  </div>
                ):(
                  <button onClick={()=>{setNoteSes(s);setNoteText("");}} style={{marginTop:8,fontSize:11,color:"#9B59B6",background:"rgba(155,89,182,0.08)",border:"1px solid rgba(155,89,182,0.2)",borderRadius:8,padding:"6px 12px",cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>
                    📝 Adaugă notă personală
                  </button>
                )}
              </div>
            ))}
          </>
        )}

        {/* ── PLAYLIST ── */}
        {view==="playlist"&&(
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div className="serif" style={{fontSize:22,color:"#2ECC71"}}>🎵 Playlist Personal</div>
              <button onClick={()=>setShowAddTrack(t=>!t)} className="btn grn sm">{showAddTrack?"✕":"+ Piesă"}</button>
            </div>
            {showAddTrack&&(
              <div className="card" style={{marginBottom:14,borderColor:"rgba(46,204,113,0.3)"}}>
                <div style={{fontSize:11,color:"#2ECC71",marginBottom:10,letterSpacing:1}}>PIESĂ NOUĂ</div>
                <div style={{display:"flex",flexDirection:"column",gap:8}}>
                  <input value={trackF.title} onChange={e=>setTrackF(t=>({...t,title:e.target.value}))} placeholder="Titlu piesă *" className="fi"/>
                  <input value={trackF.artist} onChange={e=>setTrackF(t=>({...t,artist:e.target.value}))} placeholder="Artist" className="fi"/>
                  <div style={{display:"flex",gap:8}}>
                    <input value={trackF.bpm} onChange={e=>setTrackF(t=>({...t,bpm:e.target.value}))} placeholder="BPM" className="fi" style={{flex:1}}/>
                    <input value={trackF.notes} onChange={e=>setTrackF(t=>({...t,notes:e.target.value}))} placeholder="Note" className="fi" style={{flex:2}}/>
                  </div>
                  <button onClick={addTrack} className="btn grn full">💾 Adaugă</button>
                </div>
              </div>
            )}
            {playlist.length===0&&!showAddTrack&&<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}><div style={{fontSize:36,marginBottom:8}}>🎵</div>Nicio piesă salvată încă.</div>}
            {playlist.map((t,i)=>(
              <div key={t.id} className="card" style={{padding:"12px 14px"}}>
                <div style={{display:"flex",alignItems:"center",gap:12}}>
                  <div style={{width:36,height:36,borderRadius:8,background:"rgba(46,204,113,0.1)",border:"1px solid rgba(46,204,113,0.2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,color:"#2ECC71",fontWeight:700,flexShrink:0}}>{i+1}</div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:14,fontWeight:600,color:"#eee"}} className="trunc">{t.title}</div>
                    <div style={{fontSize:11,color:"#555",marginTop:2}}>{[t.artist,t.bpm&&`${t.bpm} BPM`].filter(Boolean).join(" · ")}</div>
                    {t.notes&&<div style={{fontSize:11,color:"#888",marginTop:2,fontStyle:"italic"}}>{t.notes}</div>}
                  </div>
                  <button onClick={()=>removeTrack(t.id)} className="btn gh-r sm" style={{flexShrink:0,minHeight:28,padding:"4px 8px"}}>🗑</button>
                </div>
              </div>
            ))}
          </>
        )}

        {/* ── OBIECTIVE ── */}
        {view==="obiective"&&(
          <>
            <div className="serif" style={{fontSize:22,color:"#F39C12",marginBottom:14}}>🎯 Obiectivele mele</div>
            {obiective.length===0&&<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}><div style={{fontSize:36,marginBottom:8}}>🎯</div>Niciun obiectiv setat încă.<br/><span style={{fontSize:11,color:"#333"}}>Mentorul tău va seta obiective săptămânale.</span></div>}
            {obiective.map(ob=>(
              <div key={ob.id} className="card" style={{borderColor:ob.done?"rgba(46,204,113,0.2)":BORDER,opacity:ob.done?0.7:1}}>
                <div style={{display:"flex",alignItems:"flex-start",gap:12}}>
                  <button onClick={async()=>{if(!ob.done)await updateDoc(doc(db,"school_obiective",ob.id),{done:true,doneAt:serverTimestamp()});}} style={{width:26,height:26,borderRadius:7,background:ob.done?"#2ECC71":"rgba(255,255,255,0.05)",border:`1px solid ${ob.done?"#2ECC71":BORDER}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,color:ob.done?"#fff":"#333",cursor:ob.done?"default":"pointer",flexShrink:0,marginTop:1}}>{ob.done?"✓":""}</button>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:14,color:ob.done?"#2ECC71":"#eee",fontWeight:600,textDecoration:ob.done?"line-through":"none"}}>{ob.text}</div>
                    {ob.deadline&&<div style={{fontSize:11,color:"#555",marginTop:3}}>📅 Termen: {ob.deadline}</div>}
                    {ob.notes&&<div style={{fontSize:12,color:"#888",marginTop:4,fontStyle:"italic"}}>{ob.notes}</div>}
                  </div>
                  {ob.done&&<span style={{fontSize:10,color:"#2ECC71",flexShrink:0,marginTop:2}}>✓ Realizat</span>}
                </div>
              </div>
            ))}
          </>
        )}

        {/* ── STREAK ── */}
        {view==="streak"&&(()=>{
          const azi=new Date().toISOString().split("T")[0];
          const days=streakData.days||[];
          const markedToday=days.includes(azi);
          const last35=Array.from({length:35},(_,i)=>{const d=new Date();d.setDate(d.getDate()-34+i);return d.toISOString().split("T")[0];});
          return(
            <>
              <div className="serif" style={{fontSize:22,color:"#E67E22",marginBottom:14}}>🔥 Streak Practică</div>
              <div className="card" style={{textAlign:"center",padding:"28px 20px",borderColor:"rgba(230,126,34,0.3)",marginBottom:14}}>
                <div style={{fontSize:60,marginBottom:4,lineHeight:1}}>🔥</div>
                <div className="serif" style={{fontSize:56,fontWeight:700,color:"#E67E22",lineHeight:1}}>{streakData.streak}</div>
                <div style={{fontSize:13,color:"#888",marginTop:6}}>zile consecutive de practică</div>
                <div style={{fontSize:11,color:"#555",marginTop:4}}>{days.length} zile totale înregistrate</div>
                <button onClick={markPractice} disabled={markedToday} className="btn full" style={{marginTop:20,background:markedToday?"rgba(46,204,113,0.1)":"linear-gradient(135deg,#E67E22,#D35400)",border:markedToday?"1px solid rgba(46,204,113,0.3)":"none",color:markedToday?"#2ECC71":"#fff",borderRadius:12,padding:"14px",fontSize:14,fontFamily:"'DM Sans',sans-serif",cursor:markedToday?"default":"pointer"}}>
                  {markedToday?"✓ Ai practicat azi!":"🎧 Marchează ziua de azi"}
                </button>
              </div>
              <div style={{fontSize:11,color:"#555",marginBottom:8}}>Ultimele 35 zile</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:5}}>
                {last35.map(d=>{
                  const pract=days.includes(d);const isAzi=d===azi;
                  return(<div key={d} title={d} style={{aspectRatio:"1",borderRadius:6,background:pract?"#E67E22":isAzi?"rgba(230,126,34,0.15)":"rgba(255,255,255,0.03)",border:`1px solid ${pract?"#E67E22":isAzi?"rgba(230,126,34,0.3)":BORDER}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:9}}>{pract?"🔥":""}</div>);
                })}
              </div>
            </>
          );
        })()}

        {/* ── MIX GALLERY ── */}
        {view==="mixes"&&(
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div className="serif" style={{fontSize:22,color:"#9B59B6"}}>🎚️ Galeria mea de mix-uri</div>
              <button onClick={()=>setMixMod(true)} className="btn pur sm">+ Mix</button>
            </div>
            {mixGallery.length===0&&<div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}><div style={{fontSize:36,marginBottom:8}}>🎚️</div>Niciun mix adăugat.<br/><span style={{fontSize:11,color:"#333"}}>Uploadează mix-urile tale finite ca portofoliu.</span></div>}
            {mixGallery.map(m=>(
              <div key={m.id} className="card">
                <div style={{display:"flex",alignItems:"flex-start",gap:12}}>
                  <div style={{width:44,height:44,borderRadius:10,background:"rgba(155,89,182,0.15)",border:"1px solid rgba(155,89,182,0.25)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>🎚️</div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:14,fontWeight:600,color:"#eee"}}>{m.title}</div>
                    {m.description&&<div style={{fontSize:12,color:"#888",marginTop:3}}>{m.description}</div>}
                    <div style={{fontSize:10,color:"#444",marginTop:4}}>{m.createdAt?.toDate?new Date(m.createdAt.toDate()).toLocaleDateString("ro-RO"):""}</div>
                    {m.url&&<a href={m.url} target="_blank" rel="noreferrer" style={{fontSize:13,color:"#9B59B6",display:"inline-block",marginTop:6,fontWeight:500}}>▶ Ascultă / Descarcă</a>}
                  </div>
                  <button onClick={async()=>{if(window.confirm("Ștergi mix-ul?"))await deleteDoc(doc(db,"school_mixes",m.id));}} className="btn gh-r sm" style={{flexShrink:0,minHeight:28,padding:"4px 8px"}}>🗑</button>
                </div>
              </div>
            ))}
          </>
        )}

        {/* RESURSE CURSANT */}
        {view==="resurse"&&(
          <>
            <div className="serif" style={{fontSize:22,color:GOLD,marginBottom:4}}>📚 Resurse & Materiale</div>
            <div style={{fontSize:12,color:"#555",marginBottom:16}}>Materialele se deblochează după fiecare ședință efectuată.</div>
            {studentResources.length===0&&(
              <div style={{textAlign:"center",color:"#444",padding:40,fontSize:13}}>
                <div style={{fontSize:36,marginBottom:8}}>📚</div>
                Niciun material adăugat încă de trainer.
              </div>
            )}
            {[...Array(12)].map((_,i)=>{
              const nr=i+1;
              const res=studentResources.filter(r=>r.lessonNumber===nr);
              if(res.length===0)return null;
              const sesCompleted=allSessions.filter(s=>s.status==="completed"&&!s.source).length;
              const unlocked=nr<=sesCompleted;
              return(
                <div key={nr} className="card" style={{marginBottom:8,borderColor:unlocked?"rgba(212,175,55,0.2)":BORDER}}>
                  {/* Header ședință - mereu vizibil */}
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                      <div style={{width:28,height:28,borderRadius:7,background:unlocked?`${GOLD}18`:"rgba(255,255,255,0.03)",border:`1px solid ${unlocked?`${GOLD}44`:BORDER}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,color:unlocked?GOLD:"#444",fontWeight:700}}>{unlocked?"✓":nr}</div>
                      <div style={{fontSize:12,fontWeight:600,color:unlocked?GOLD:"#555",letterSpacing:1}}>ȘEDINȚA {nr}</div>
                    </div>
                    {unlocked
                      ? <div style={{fontSize:10,color:"#2ECC71"}}>✓ Deblocat</div>
                      : <div style={{fontSize:10,color:"#444"}}>🔒 După ședința {nr}</div>
                    }
                  </div>
                  {/* Lista resurse */}
                  {res.map(r=>(
                    <div key={r.id} style={{display:"flex",alignItems:"center",gap:12,padding:"9px 0",borderTop:"1px solid rgba(255,255,255,0.05)"}}>
                      <div style={{fontSize:18,opacity:unlocked?1:0.3}}>{r.type==="pdf"?"📄":r.type==="video"?"🎬":r.type==="link"?"🔗":"📝"}</div>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:13,fontWeight:600,color:unlocked?"#eee":"#555"}}>{r.title}</div>
                        {r.description&&<div style={{fontSize:11,color:unlocked?"#666":"#444",marginTop:2}}>{r.description}</div>}
                        {unlocked
                          ? r.url&&<a href={r.url} target="_blank" rel="noreferrer" style={{fontSize:12,color:"#3498DB",display:"inline-block",marginTop:4,fontWeight:500}}>Deschide →</a>
                          : <div style={{fontSize:11,color:"#333",marginTop:4,fontStyle:"italic"}}>Disponibil după ședința {nr}</div>
                        }
                      </div>
                      {!unlocked&&<div style={{fontSize:16,opacity:0.25,flexShrink:0}}>🔒</div>}
                    </div>
                  ))}
                </div>
              );
            })}
          </>
        )}

        {view==="qr"&&(
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",paddingTop:10}}>
            <div className="serif gt" style={{fontSize:24,fontWeight:600,marginBottom:4}}>⬡ Codul tău QR</div>
            <div style={{fontSize:12,color:"#444",marginBottom:22,textAlign:"center"}}>Prezintă la studio pentru înregistrarea prezenței</div>
            {qrUrl&&(
              <div className="card" style={{textAlign:"center",padding:"22px 20px",borderColor:"rgba(212,175,55,0.2)",width:"100%",maxWidth:320}}>
                <img src={qrUrl} alt="QR" style={{width:"100%",maxWidth:240,height:"auto",borderRadius:12}}/>
                <div style={{fontSize:15,fontWeight:600,color:"#eee",marginTop:14}}>{user.name}</div>
                <div style={{fontSize:11,color:"#444",marginTop:3}}>{user.email}</div>
                <a href={qrUrl} download={`qr-${user.name}.png`} className="btn gold full" style={{display:"flex",marginTop:16}}>⬇ Descarcă QR</a>
              </div>
            )}
          </div>
        )}

      </div>
      <BottomNav items={navItems} active={view} onChange={setView} onLogout={onLogout}/>

      <Modal open={upMod} onClose={()=>setUpMod(false)}>
        <div className="serif" style={{fontSize:20,color:"#9B59B6",marginBottom:14}}>⬆ Upload video pentru review</div>
        <div className="f"><label>Fișier video</label><input className="fi" type="file" accept="video/*" onChange={e=>setUpFile(e.target.files[0])}/></div>
        <F label="Notă pentru mentor (opțional)" multiline value={upNote} onChange={e=>setUpNote(e.target.value)} rows={3} placeholder="Ex: Mix de la min 2:30..."/>
        <button onClick={uploadVideo} disabled={uploading} className="btn pur full">{uploading?"Se încarcă...":"Trimite video"}</button>
      </Modal>

      {/* MODAL FEEDBACK CURSANT */}
      <Modal open={!!feedbackSes} onClose={()=>setFeedbackSes(null)}>
        <div className="serif" style={{fontSize:20,color:"#3498DB",marginBottom:8}}>💬 Răspunde mentorului</div>
        {feedbackSes&&<div style={{fontSize:11,color:"#555",marginBottom:14}}>{feedbackSes.date} · {feedbackSes.time}</div>}
        <textarea value={feedbackText} onChange={e=>setFeedbackText(e.target.value)} placeholder="Cum a mers ședința pentru tine? Ce ți-a plăcut, ce îți este mai greu?" rows={5} style={{width:"100%",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(52,152,219,0.25)",borderRadius:10,padding:"12px 14px",color:"#eee",fontSize:14,resize:"vertical",outline:"none",marginBottom:12}}/>
        <button onClick={saveStudentFeedback} disabled={feedbackSaving} className="btn full" style={{background:"rgba(52,152,219,0.15)",border:"1px solid rgba(52,152,219,0.3)",color:"#3498DB",borderRadius:10,padding:"12px",fontSize:14,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>
          {feedbackSaving?"Se salvează...":"Trimite răspunsul"}
        </button>
      </Modal>

      {/* MODAL NOTA PERSONALA */}
      <Modal open={!!noteSes} onClose={()=>setNoteSes(null)}>
        <div className="serif" style={{fontSize:20,color:"#9B59B6",marginBottom:8}}>📝 Nota mea personală</div>
        {noteSes&&<div style={{fontSize:11,color:"#555",marginBottom:14}}>{noteSes.date} · {noteSes.time}</div>}
        <textarea value={noteText} onChange={e=>setNoteText(e.target.value)} placeholder="Ce ai învățat azi? Ce ți-a fost greu? La ce trebuie să lucrezi mai mult?" rows={6} style={{width:"100%",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(155,89,182,0.25)",borderRadius:10,padding:"12px 14px",color:"#eee",fontSize:14,resize:"vertical",outline:"none",marginBottom:12}}/>
        <button onClick={saveNota} disabled={noteSaving} className="btn full" style={{background:"rgba(155,89,182,0.15)",border:"1px solid rgba(155,89,182,0.3)",color:"#9B59B6",borderRadius:10,padding:"12px",fontSize:14,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>
          {noteSaving?"Se salvează...":"💾 Salvează nota"}
        </button>
      </Modal>

      {/* MODAL UPLOAD MIX */}
      <Modal open={mixMod} onClose={()=>setMixMod(false)}>
        <div className="serif" style={{fontSize:20,color:"#9B59B6",marginBottom:14}}>🎚️ Adaugă mix în galerie</div>
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          <input value={mixTitle} onChange={e=>setMixTitle(e.target.value)} placeholder="Titlu mix *" className="fi"/>
          <textarea value={mixDesc} onChange={e=>setMixDesc(e.target.value)} placeholder="Descriere (opțional)" rows={3} style={{width:"100%",background:"rgba(255,255,255,0.04)",border:`1px solid ${BORDER}`,borderRadius:10,padding:"10px 14px",color:"#eee",fontSize:13,resize:"none",outline:"none"}}/>
          <div className="f"><label style={{fontSize:11,color:"#555",display:"block",marginBottom:6}}>Fișier audio / video</label><input type="file" accept="audio/*,video/*" onChange={e=>setMixFile(e.target.files[0])} className="fi"/></div>
          <button onClick={uploadMix} disabled={mixUploading} className="btn pur full">{mixUploading?"Se încarcă...":"⬆ Adaugă în galerie"}</button>
        </div>
      </Modal>
    </div>
  );
}

// ════════════════════════════════════════════════
// APP ROOT
// ════════════════════════════════════════════════
export default function App() {
  const [user,setUser]=useState(null);
  const [loading,setLoading]=useState(true);
  const [toast,setToast]=useState(null);
  const showToast=useCallback((msg,type="success")=>setToast({msg,type}),[]);

  useEffect(()=>{
    try{
      const saved=localStorage.getItem("school_session");
      if(saved){
        const parsed=JSON.parse(saved);
        if(!parsed?.uid){setLoading(false);return;}
        getDoc(doc(db,"school_users",parsed.uid)).then(snap=>{
          if(snap.exists()&&snap.data().active){
            const fresh={uid:parsed.uid,...snap.data()};
            localStorage.setItem("school_session",JSON.stringify(fresh));
            setUser(fresh);
          }else{
            localStorage.removeItem("school_session");
          }
          setLoading(false);
        }).catch(()=>{setUser(parsed);setLoading(false);});
      }else{
        setLoading(false);
      }
    }catch{
      localStorage.removeItem("school_session");
      setLoading(false);
    }
  },[]);

  const logout=()=>{localStorage.removeItem("school_session");setUser(null);};

  if(loading)return(
    <div style={{minHeight:"100vh",background:DARK,display:"flex",alignItems:"center",justifyContent:"center"}}>
      <style>{CSS}</style>
      <div style={{textAlign:"center"}}>
        <div className="serif gt" style={{fontSize:28,fontWeight:600}}>DJ School</div>
        <div style={{fontSize:11,color:"#333",marginTop:10,letterSpacing:3}}>SE ÎNCARCĂ...</div>
      </div>
    </div>
  );

  return(
    <>
      {!user                  &&<LoginPage   onLogin={setUser}    toast={showToast}/>}
      {user?.role==="admin"   &&<AdminDashboard   user={user} onLogout={logout} toast={showToast}/>}
      {user?.role==="mentor"  &&<MentorDashboard  user={user} onLogout={logout} toast={showToast}/>}
      {user?.role==="student" &&<StudentDashboard user={user} onLogout={logout} toast={showToast}/>}
      {toast&&<Toast msg={toast.msg} type={toast.type} onClose={()=>setToast(null)}/>}
    </>
  );
}
